"use strict";
/*
 * @Author: 张帮辉
 * @LastEditors: 王仁涛 wangrt@cnlemon.net
 * @Date: 2022-03-28 16:01:04
 * @LastEditTime: 2026-02-28 17:15:46
 * @Description: 权限
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPermissonCodeKey = exports.IPermissonCode = void 0;
var IPermissonCode;
(function (IPermissonCode) {
    /** 空码制作 */
    IPermissonCode["PERMISSION_OPERATE_SETTING_CATEGORY_QR_CODE_EMPTY"] = "PERMISSION_OPERATE_SETTING_CATEGORY_QR_CODE_EMPTY";
    /** 桌台点餐码 */
    IPermissonCode["PERMISSION_OPERATE_SETTING_CATEGORY_QR_CODE_TABLE"] = "PERMISSION_OPERATE_SETTING_CATEGORY_QR_CODE_TABLE";
    /** 二维码管理 */
    IPermissonCode["PERMISSION_OPERATE_SETTING_CATEGORY_QR_CODE"] = "PERMISSION_OPERATE_SETTING_CATEGORY_QR_CODE";
    /** 套餐页面装修 */
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_KIT_DETAIL"] = "PERMISSION_WESTORE_SHOP_DECORATION_KIT_DETAIL";
    /** 主页 */
    IPermissonCode["PERMISSION_STOCK_PURCHASE_TMPL"] = "PERMISSION_STOCK_PURCHASE_TMPL";
    /** 数据概况 */
    IPermissonCode["PERMISSION_MAIN_DATA_OVERVIEW"] = "PERMISSION_MAIN_DATA_OVERVIEW";
    /** 成套件档案*/
    IPermissonCode["PERMISSION_FILES_PRODUCT_VARIANT_MATERIAL"] = "PERMISSION_FILES_PRODUCT_VARIANT_MATERIAL";
    /** 待办事项*/
    IPermissonCode["PERMISSION_MAIN_TO_DO"] = "PERMISSION_MAIN_TO_DO";
    /** 商品销售TOP10 */
    IPermissonCode["PERMISSION_MAIN_PRODUCT_TOP"] = "PERMISSION_MAIN_PRODUCT_TOP";
    /** 会员卡共享分组*/
    IPermissonCode["PERMISSION_CUSTOMER_CARD_SHARE_GROUP"] = "PERMISSION_CUSTOMER_CARD_SHARE_GROUP";
    /** 抖音自助核销授权管理 */
    IPermissonCode["PERMISSION_OMS_TIKTOK_SELF_CHECK_AUTHROIZE_MANAGE"] = "PERMISSION_OMS_TIKTOK_SELF_CHECK_AUTHROIZE_MANAGE";
    /** 抖音自助核销门店商品 */
    IPermissonCode["PERMISSION_OMS_TIKTOK_SELF_CHECK_LOCATION_PRODUCT"] = "PERMISSION_OMS_TIKTOK_SELF_CHECK_LOCATION_PRODUCT";
    /**抖音自助核销门店列表 */
    IPermissonCode["PERMISSION_OMS_TIKTOK_SELF_CHECK_LOCATION_SET"] = "PERMISSION_OMS_TIKTOK_SELF_CHECK_LOCATION_SET";
    /** 门店设置 */
    IPermissonCode["PERMISSION_OMS_EL_LOCATION_SET"] = "PERMISSION_OMS_EL_LOCATION_SET";
    /** 门店商品 */
    IPermissonCode["PERMISSION_OMS_EL_LOCATION_PRODUCT"] = "PERMISSION_OMS_EL_LOCATION_PRODUCT";
    /** 淘宝闪购·餐饮设置 */
    IPermissonCode["PERMISSION_OMS_EL_SETTING"] = "PERMISSION_OMS_EL_SETTING";
    /** 授权管理 */
    IPermissonCode["PERMISSION_OMS_MT_AUTHROIZE_MANAGE"] = "PERMISSION_OMS_MT_AUTHROIZE_MANAGE";
    /** 门店商品 */
    IPermissonCode["PERMISSION_OMS_MT_LOCATION_PRODUCT"] = "PERMISSION_OMS_MT_LOCATION_PRODUCT";
    /** 美团设置 */
    IPermissonCode["PERMISSION_OMS_MT_SETTING"] = "PERMISSION_OMS_MT_SETTING";
    /** 饿百零售授权管理 */
    IPermissonCode["PERMISSION_OMS_EB_AUTHROIZE_MANAGE"] = "PERMISSION_OMS_EB_AUTHROIZE_MANAGE";
    /** 饿百零售门店商品 */
    IPermissonCode["PERMISSION_OMS_EB_LOCATION_PRODUCT"] = "PERMISSION_OMS_EB_LOCATION_PRODUCT";
    /**饿百零售门店列表 */
    IPermissonCode["PERMISSION_OMS_EB_LOCATION_SET"] = "PERMISSION_OMS_EB_LOCATION_SET";
    /** 饿百零售设置 */
    IPermissonCode["PERMISSION_OMS_EB_SETTING"] = "PERMISSION_OMS_EB_SETTING";
    /** 抖音外卖授权管理 */
    IPermissonCode["PERMISSION_OMS_TIKTOK_AUTHROIZE_MANAGE"] = "PERMISSION_OMS_TIKTOK_AUTHROIZE_MANAGE";
    /** 抖音外卖门店商品 */
    IPermissonCode["PERMISSION_OMS_TIKTOK_LOCATION_PRODUCT"] = "PERMISSION_OMS_TIKTOK_LOCATION_PRODUCT";
    /**抖音外卖门店列表 */
    IPermissonCode["PERMISSION_OMS_TIKTOK_LOCATION_SET"] = "PERMISSION_OMS_TIKTOK_LOCATION_SET";
    /** 抖音外卖设置 */
    IPermissonCode["PERMISSION_OMS_TIKTOK_SETTING"] = "PERMISSION_OMS_TIKTOK_SETTING";
    /** 授权管理 */
    IPermissonCode["PERMISSION_OMS_EL_AUTHROIZE_MANAGE"] = "PERMISSION_OMS_EL_AUTHROIZE_MANAGE";
    IPermissonCode["PERMISSION_AGGREGATE_TRANSFER_ORDER"] = "PERMISSION_AGGREGATE_TRANSFER_ORDER";
    IPermissonCode["PERMISSION_PLATFORM_LOCATION"] = "PERMISSION_PLATFORM_LOCATION";
    IPermissonCode["PERMISSION_SETTING_EVALUATION_SETTING"] = "PERMISSION_SETTING_EVALUATION_SETTING";
    // 外卖平台API调用
    IPermissonCode["PERMISSION_MEITUAN_TAKEOUT_API_CALL"] = "PERMISSION_MEITUAN_TAKEOUT_API_CALL";
    // 平台小程序调用
    IPermissonCode["PERMISSION_PLATFORM_APPLET_CALL"] = "PERMISSION_PLATFORM_APPLET_CALL";
    IPermissonCode["PERMISSION_SETTING_BILL_PLEASE"] = "PERMISSION_SETTING_BILL_PLEASE";
    IPermissonCode["PERMISSION_SERVICE_MARKET"] = "PERMISSION_SERVICE_MARKET";
    /** 临时POS授权点数管理 */
    IPermissonCode["PERMISSION_SERVICE_TEMP_POS_LIMIT"] = "PERMISSION_SERVICE_TEMP_POS_LIMIT";
    IPermissonCode["PERMISSION_SERVICE_MY_PURCHASE"] = "PERMISSION_SERVICE_MY_PURCHASE";
    // 费用订单
    IPermissonCode["PERMISSION_SERVICE_FINANCE"] = "PERMISSION_SERVICE_FINANCE";
    // 发票管理
    IPermissonCode["PERMISSION_INVOICE_MANAGEMENT"] = "PERMISSION_INVOICE_MANAGEMENT";
    // 合同管理
    IPermissonCode["PERMISSION_CONTRACT_MANAGEMENT"] = "PERMISSION_CONTRACT_MANAGEMENT";
    /** 扫码定单 */
    IPermissonCode["PERMISSION_SETTING_SCAN_CODE_PAY"] = "PERMISSION_SETTING_SCAN_CODE_PAY";
    /** 成本卡*/
    IPermissonCode["PERMISSION_FILES_COST_CARD"] = "PERMISSION_FILES_COST_CARD";
    /** 替代品管理*/
    IPermissonCode["PERMISSION_FILES_REPLACE_ITEM"] = "PERMISSION_FILES_REPLACE_ITEM";
    /** 虚拟物品档案*/
    IPermissonCode["PERMISSION_FILES_VIRTUAL_ITEM"] = "PERMISSION_FILES_VIRTUAL_ITEM";
    /** 仓库档案*/
    IPermissonCode["PERMISSION_CHAIN_STORE_DOCUMENT"] = "PERMISSION_FILES_WAREHOUSE_FILES";
    /** 仓库物品规则 */
    IPermissonCode["PERMISSION_WAREHOUSE_ITEM_RULES"] = "PERMISSION_WAREHOUSE_ITEM_RULES";
    /** 物品分类*/
    IPermissonCode["PERMISSION_CHAIN_STORE_CATEGORY"] = "PERMISSION_FILES_PRODUCT_TYPE";
    /** 品牌*/
    IPermissonCode["PERMISSION_CHAIN_STORE_BRAND"] = "PERMISSION_FILES_PRODUCT_VENDOR";
    /** 档案设置*/
    IPermissonCode["PERMISSION_CHAIN_STORE_SETTING"] = "PERMISSION_FILES_SETTING";
    /** 要货单 */
    IPermissonCode["PERMISSION_CHAIN_REQUEST_ORDER"] = "PERMISSION_CHAIN_REQUEST_ORDER";
    /** 调出单 */
    IPermissonCode["PERMISSION_CHAIN_TRANSFER_OUT_ORDER"] = "PERMISSION_CHAIN_TRANSFER_OUT_ORDER";
    /** 调入单 */
    IPermissonCode["PERMISSION_CHAIN_TRANSFER_IN_ORDER"] = "PERMISSION_CHAIN_TRANSFER_IN_ORDER";
    /** 内部申请单 */
    IPermissonCode["PERMISSION_CHAIN_INNER_APPLY_ORDER"] = "PERMISSION_CHAIN_INNER_APPLY_ORDER";
    /** 要货单统计 */
    IPermissonCode["PERMISSION_CHAIN_REQUEST_ORDER_STATISTICS"] = "PERMISSION_CHAIN_REQUEST_ORDER_STATISTICS";
    /** 要货单 */
    IPermissonCode["PERMISSION_CHAIN_TRANSFER_OUT_ORDER_REPORT"] = "PERMISSION_CHAIN_TRANSFER_OUT_ORDER_REPORT";
    /** 调出单统计 */
    IPermissonCode["PERMISSION_CHAIN_TRANSFER_IN_ORDER_REPORT"] = "PERMISSION_CHAIN_TRANSFER_IN_ORDER_REPORT";
    /** 内部申请单统计 */
    IPermissonCode["PERMISSION_CHAIN_INNER_APPLY_ORDER_REPORT"] = "PERMISSION_CHAIN_INNER_APPLY_ORDER_REPORT";
    /** 供应商 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER"] = "PERMISSION_STOCK_SUPPLIER";
    /** 收货单 */
    IPermissonCode["PERMISSION_CHAIN_RECEIVE_ORDER"] = "PERMISSION_CHAIN_RECEIVE_ORDER";
    /** 盘点单 */
    IPermissonCode["PERMISSION_STOCK_CHECK_ORDER"] = "PERMISSION_STOCK_CHECK_ORDER";
    /** 库存转仓 */
    IPermissonCode["PERMISSION_STOCK_TRANSFER_STOREHOUSE"] = "PERMISSION_STOCK_TRANSFER_STOREHOUSE";
    /** 会计期 */
    IPermissonCode["PERMISSION_STOCK_FINANCIAL_ACCOUNT_PERIOD"] = "PERMISSION_STOCK_FINANCIAL_ACCOUNT_PERIOD";
    /** 财务结转 */
    IPermissonCode["PERMISSION_STOCK_FINANCIAL_ACCOUNT_SETTLEMENT"] = "PERMISSION_STOCK_FINANCIAL_ACCOUNT_SETTLEMENT";
    /** 库存成本调整 */
    IPermissonCode["PERMISSION_STOCK_INVENTORY_COST_ADJUST"] = "PERMISSION_STOCK_INVENTORY_COST_ADJUST";
    /** 库存成本重算 */
    IPermissonCode["PERMISSION_STOCK_INVENTORY_COST_RECAL"] = "PERMISSION_STOCK_INVENTORY_COST_RECAL";
    /** 配送 */
    IPermissonCode["PERMISSION_CHAIN_SHIP_NET"] = "PERMISSION_CHAIN_SHIP_NET";
    /** 库存调整原因 */
    IPermissonCode["PERMISSION_STOCK_ADJUSTMENT_REASON"] = "PERMISSION_STOCK_ADJUSTMENT_REASON";
    /** 库存调整单 */
    IPermissonCode["PERMISSION_STOCK_ADJUSTMENT_ORDER"] = "PERMISSION_STOCK_ADJUSTMENT_ORDER";
    /** 采购订单 */
    IPermissonCode["PERMISSION_STOCK_PURCHASE_ORDER"] = "PERMISSION_STOCK_PURCHASE_ORDER";
    /** 供应商直发单 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_DIRECT_ORDER"] = "PERMISSION_STOCK_SUPPLIER_DIRECT_ORDER";
    /** 退货单 */
    IPermissonCode["PERMISSION_STOCK_RETURN_ORDER"] = "PERMISSION_STOCK_RETURN_ORDER";
    /** 加工品管理 */
    IPermissonCode["PERMISSION_STOCK_PRODUCT_PRODUCE_MGR"] = "PERMISSION_STOCK_PRODUCT_PRODUCE_MGR";
    /** 配方管理 */
    IPermissonCode["PERMISSION_STOCK_PRODUCT_FORMULA"] = "PERMISSION_STOCK_PRODUCT_FORMULA";
    /** 生产计划单 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_PLAN_ORDER"] = "PERMISSION_STOCK_PRODUCE_PLAN_ORDER";
    /** 生产看板 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_BOARD"] = "PERMISSION_STOCK_PRODUCE_BOARD";
    /** 生产任务单 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_TASK"] = "PERMISSION_STOCK_PRODUCE_TASK";
    /** 生产领料单 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_MATERIAL_ORDER"] = "PERMISSION_STOCK_PRODUCE_MATERIAL_ORDER";
    /** 快速生产单 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_FAST_ORDER"] = "PERMISSION_STOCK_PRODUCE_FAST_ORDER";
    /** 出品率报表 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_PROCESS_RATE"] = "PERMISSION_STOCK_PRODUCE_PROCESS_RATE";
    /** 生产入库单 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_STORAGE_ORDER"] = "PERMISSION_STOCK_PRODUCE_STORAGE_ORDER";
    /** 加工间任务看板 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_TASK_BOARD"] = "PERMISSION_STOCK_PRODUCE_TASK_BOARD";
    /** 门店加工单 */
    IPermissonCode["PERMISSION_STOCK_LOCATION_PRODUCE"] = "PERMISSION_STOCK_LOCATION_PRODUCE";
    /** 门店配送价 */
    IPermissonCode["PERMISSION_CHAIN_PRODUCT_LOCATION"] = "PERMISSION_CHAIN_PRODUCT_LOCATION";
    /** 商品毛利 */
    IPermissonCode["PERMISSION_PRODUCT_DISTRIBUTION_GROSS_PROFIT"] = "PERMISSION_PRODUCT_DISTRIBUTION_GROSS_PROFIT";
    /** 门店毛利 */
    IPermissonCode["PERMISSION_LOCATION_DISTRIBUTION_GROSS_PROFIT"] = "PERMISSION_LOCATION_DISTRIBUTION_GROSS_PROFIT";
    /** 门店商品毛利对比 */
    IPermissonCode["PERMISSION_LOCATION_PRODUCT_GROSS_CONTRAST"] = "PERMISSION_LOCATION_PRODUCT_GROSS_CONTRAST";
    /** 配送毛利 */
    IPermissonCode["PERMISSION_CHAIN_DISTRIBUTION_GROSS_PROFIT"] = "PERMISSION_CHAIN_DISTRIBUTION_GROSS_PROFIT";
    /** 配送属性 */
    IPermissonCode["PERMISSION_CHAIN_PRODUCT_LOCATION_PROP"] = "PERMISSION_CHAIN_PRODUCT_LOCATION_PROP";
    /** 采购属性 */
    IPermissonCode["PERMISSION_STOCK_PRODUCT_LOCATION_PURCHASE"] = "PERMISSION_STOCK_PRODUCT_LOCATION_PURCHASE";
    /** 设置 */
    IPermissonCode["PERMISSION_SETTING_CHAIN_STOCK"] = "PERMISSION_SETTING_CHAIN_STOCK";
    /** APP物品列表配置 */
    IPermissonCode["PERMISSION_STOCK_APP_ITEM_LIST_SETTING"] = "PERMISSION_STOCK_APP_ITEM_LIST_SETTING";
    /** 商品在途 */
    IPermissonCode["PERMISSION_CHAIN_PRODUCT_IN_TRANSIT"] = "PERMISSION_CHAIN_PRODUCT_IN_TRANSIT";
    /** 采购汇总明细 */
    IPermissonCode["PERMISSION_PURCHASE_SUMMARY_DETAIL"] = "PERMISSION_PURCHASE_SUMMARY_DETAIL";
    /** 物品供货关系 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_PRODUCT"] = "PERMISSION_STOCK_SUPPLIER_PRODUCT";
    /** 物品库存 */
    IPermissonCode["PERMISSION_STOCK_PRODUCT_STOCK"] = "PERMISSION_STOCK_PRODUCT_STOCK";
    /** 库存进出明细 */
    IPermissonCode["PERMISSION_FILES_PRODUCT_IN_OUT_DETAIL"] = "PERMISSION_FILES_PRODUCT_IN_OUT_DETAIL";
    /** 库存进出汇总 */
    IPermissonCode["PERMISSION_STOCK_INVENTORY_IN_OUT_SUMMARY"] = "PERMISSION_STOCK_INVENTORY_IN_OUT_SUMMARY";
    /** 入库汇总 */
    IPermissonCode["PERMISSION_STOCK_INVENTORY_IN_SUMMARY"] = "PERMISSION_STOCK_INVENTORY_IN_SUMMARY";
    /** 出库汇总 */
    IPermissonCode["PERMISSION_STOCK_INVENTORY_OUT_SUMMARY"] = "PERMISSION_STOCK_INVENTORY_OUT_SUMMARY";
    /**进销存变动统计 */
    IPermissonCode["PERMISSION_STOCK_STATISTICS_OF_CHANGE"] = "PERMISSION_STOCK_STATISTICS_OF_CHANGE";
    /** 损益统计表 */
    IPermissonCode["PERMISSION_STOCK_GAIN_LOSS_REPORT"] = "PERMISSION_STOCK_GAIN_LOSS_REPORT";
    /** 门店订货控制 */
    IPermissonCode["PERMISSION_CHAIN_LOCATION_REQUEST_CONTROL"] = "PERMISSION_CHAIN_LOCATION_REQUEST_CONTROL";
    /** 门店要货模板 */
    IPermissonCode["PERMISSION_STOCK_REQUEST_ORDER_TEMPLATE"] = "PERMISSION_STOCK_REQUEST_ORDER_TEMPLATE";
    /** 退货申请原因 */
    IPermissonCode["PERMISSION_STOCK_INNER_RETURN_REASON"] = "PERMISSION_STOCK_INNER_RETURN_REASON";
    /** 物品查询模板 */
    IPermissonCode["PERMISSION_STOCK_ITEM_QUERY_TMPL"] = "PERMISSION_STOCK_ITEM_QUERY_TMPL";
    /** 物品角标 */
    IPermissonCode["PERMISSION_ITEM_CORNER_MARK"] = "PERMISSION_ITEM_CORNER_MARK";
    /** 供应链参数 */
    IPermissonCode["PARENT_PERMISSION_STOCK_SETTING"] = "PARENT_PERMISSION_STOCK_SETTING";
    /** 打印模板设置 */
    IPermissonCode["PERMISSION_STOCK_SETTING_PRINT_TMPL"] = "PERMISSION_STOCK_SETTING_PRINT_TMPL";
    /** 效期汇总 */
    IPermissonCode["PERMISSION_VALIDITY_SUMMARY"] = "PERMISSION_VALIDITY_SUMMARY";
    /** 效期看板 */
    IPermissonCode["PERMISSION_VALIDITY_BOARD"] = "PERMISSION_VALIDITY_BOARD";
    /** 储存条件 */
    IPermissonCode["PERMISSION_VALIDITY_STORAGE_CONDITION"] = "PERMISSION_VALIDITY_STORAGE_CONDITION";
    /** 效期商品 */
    IPermissonCode["PERMISSION_VALIDITY_PRODUCT"] = "PERMISSION_VALIDITY_PRODUCT";
    /** 配送结算 */
    IPermissonCode["PERMISSION_STOCK_FINANCIAL_DELIVER_SETTLEMENT"] = "PERMISSION_STOCK_FINANCIAL_DELIVER_SETTLEMENT";
    /** 供应商预付 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_PRE_PAY"] = "PERMISSION_STOCK_SUPPLIER_PRE_PAY";
    /** 供应商结算 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_SETTLEMENT_SUB"] = "PERMISSION_STOCK_SUPPLIER_SETTLEMENT_SUB";
    /** 门店往来账款 */
    IPermissonCode["PERMISSION_STOCK_LOCATION_ACCOUNT_AMOUNT"] = "PERMISSION_STOCK_LOCATION_ACCOUNT_AMOUNT";
    /** 门店预收 */
    IPermissonCode["PERMISSION_STOCK_LOCATION_PRE_RECEIVE"] = "PERMISSION_STOCK_LOCATION_PRE_RECEIVE";
    /** 费用项目 */
    IPermissonCode["PERMISSION_STOCK_FINANCE_FEE_ITEM"] = "PERMISSION_STOCK_FINANCE_FEE_ITEM";
    /** 供应商往来账款 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_ACCOUNT_AMOUNT"] = "PERMISSION_STOCK_SUPPLIER_ACCOUNT_AMOUNT";
    /** 供应商预付汇总 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_PRE_PAY_SUMMARY"] = "PERMISSION_STOCK_SUPPLIER_PRE_PAY_SUMMARY";
    /** 门店预付汇总 */
    IPermissonCode["PERMISSION_STOCK_LOCATION_PRE_RECEIVE_SUMMARY"] = "PERMISSION_STOCK_LOCATION_PRE_RECEIVE_SUMMARY";
    /** 门店费用 */
    IPermissonCode["PERMISSION_STOCK_LOCATION_FEE"] = "PERMISSION_STOCK_LOCATION_FEE";
    /** 供应商费用 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_FEE"] = "PERMISSION_STOCK_SUPPLIER_FEE";
    /** 供应商费用汇总 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_FEE_SUMMARY"] = "PERMISSION_STOCK_SUPPLIER_FEE_SUMMARY";
    /** 生产模板 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_TMPL"] = "PERMISSION_STOCK_PRODUCE_TMPL";
    /** 作业人员 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_OPERATOR"] = "PERMISSION_STOCK_PRODUCE_OPERATOR";
    /** 标签打印 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_TAG_PRINT"] = "PERMISSION_STOCK_PRODUCE_TAG_PRINT";
    /** 供应商用户 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_USER"] = "PERMISSION_STOCK_SUPPLIER_USER";
    /** 供应商角色 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_ROLE"] = "PERMISSION_STOCK_SUPPLIER_USER_ROLE";
    /** 供应商微信解绑 */
    IPermissonCode["PERMISSION_STOCK_SUPPLIER_WECHAT_UNBIND"] = "PERMISSION_STOCK_SUPPLIER_WECHAT_UNBIND";
    /** 营业优惠分析 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_DISCOUNT"] = "PERMISSION_ANALYZE_BUSINESS_DISCOUNT";
    /** 营业收入构成 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_PAYMENT"] = "PERMISSION_ANALYZE_BUSINESS_PAYMENT";
    /** 营业明细 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_DETAIL"] = "PERMISSION_ANALYZE_BUSINESS_DETAIL";
    /** 营业外统计 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_BEYOND_STATISTICS"] = "PERMISSION_ANALYZE_BUSINESS_BEYOND_STATISTICS";
    /** 营业统计 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_STATISTICS"] = "PERMISSION_ANALYZE_BUSINESS_STATISTICS";
    /** 营业退款统计 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_REFUND_STATISTICS"] = "PERMISSION_ANALYZE_BUSINESS_REFUND_STATISTICS";
    /** 渠道营业统计 */
    IPermissonCode["PERMISSION_ANALYZE_ORDER_BUSINESS_REPORT_ANALYSIS"] = "PERMISSION_ANALYZE_ORDER_BUSINESS_REPORT_ANALYSIS";
    /** 餐区/台位营业统计 */
    IPermissonCode["PERMISSION_ANALYZE_TABLE_BUSINESS_STATISTICS"] = "PERMISSION_ANALYZE_TABLE_BUSINESS_STATISTICS";
    /** 餐/时段营业统计 */
    IPermissonCode["PERMISSION_ANALYZE_SESSION_BUSINESS_STATISTICS"] = "PERMISSION_ANALYZE_SESSION_BUSINESS_STATISTICS";
    /** 券收入统计 */
    IPermissonCode["PERMISSION_ANALYZE_TICKET_INCOME_STATISTICS"] = "PERMISSION_ANALYZE_TICKET_INCOME_STATISTICS";
    /** 快递商城统计 */
    IPermissonCode["PERMISSION_ANALYZE_EXPRESS_MALL_STATISTICS"] = "PERMISSION_ANALYZE_EXPRESS_MALL_STATISTICS";
    /**商品概览 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_OVERVIEW_REPORT"] = "PERMISSION_ANALYZE_PRODUCT_OVERVIEW_REPORT";
    /**商品汇总 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_SUMMARY"] = "PERMISSION_ANALYZE_PRODUCT_SUMMARY";
    /**商品销售汇总 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_SALES_SUMMARY"] = "PERMISSION_ANALYZE_PRODUCT_SALES_SUMMARY";
    /**商品销售明细 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_SALES_DETAIL"] = "PERMISSION_ANALYZE_PRODUCT_SALES_DETAIL";
    /**商品门店销售汇总 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_LOCATION_SALES"] = "PERMISSION_ANALYZE_PRODUCT_LOCATION_SALES";
    /**退货/退菜报表 */
    IPermissonCode["PERMISSION_ANALYZE_SESSION_PRODUCT_REFUND_STATISTICS"] = "PERMISSION_ANALYZE_SESSION_PRODUCT_REFUND_STATISTICS";
    /**赠品统计 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_GIFT_STATISTICS"] = "PERMISSION_ANALYZE_PRODUCT_GIFT_STATISTICS";
    /** 加料销售统计 */
    IPermissonCode["PERMISSION_ANALYZE_PROPERTY_SALE_STATISTICS"] = "PERMISSION_ANALYZE_PROPERTY_SALE_STATISTICS";
    /** 做法统计 */
    IPermissonCode["PERMISSION_ANALYZE_MAKE_METHOD_STATISTICS"] = "PERMISSION_ANALYZE_MAKE_METHOD_STATISTICS";
    /** 商品销售排行 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_SALES_RANKING"] = "PERMISSION_ANALYZE_PRODUCT_SALES_RANKING";
    /** 商品营销统计 */
    IPermissonCode["PERMISSION_PRODUCT_MARKETING_REPORT"] = "PERMISSION_PRODUCT_MARKETING_REPORT";
    /** 会员扣款记录 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_CONSUME_DETAIL_ANALYSIS"] = "PERMISSION_ANALYZE_CUSTOMER_CONSUME_DETAIL_ANALYSIS";
    /** 储值支付方式明细 */
    IPermissonCode["PERMISSION_ANALYZE_DEPOSIT_PAYMENT_TYPE_DETAIL_ANALYSIS"] = "PERMISSION_ANALYZE_DEPOSIT_PAYMENT_TYPE_DETAIL_ANALYSIS";
    /** 会员储值明细 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_DEPOSIT_DETAIL_ANALYSIS"] = "PERMISSION_ANALYZE_CUSTOMER_DEPOSIT_DETAIL_ANALYSIS";
    /** 储值消费店间结算 */
    IPermissonCode["PERMISSION_ANALYZE_CROSS_LOCATION_CONSUME"] = "PERMISSION_ANALYZE_CROSS_LOCATION_CONSUME";
    /** 储值活动效果分析 */
    IPermissonCode["PERMISSION_ANALYZE_GIFT_DEPOSIT"] = "PERMISSION_ANALYZE_GIFT_DEPOSIT";
    /** 会员卡操作明细 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_CARD_OPERATE_LOG"] = "PERMISSION_ANALYZE_CUSTOMER_CARD_OPERATE_LOG";
    /** 会员概览 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_MEMBER_DATA"] = "PERMISSION_ANALYZE_CUSTOMER_MEMBER_DATA";
    /** 会员卡交易流水 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_CARD_TRADE_LOG"] = "PERMISSION_ANALYZE_CUSTOMER_CARD_TRADE_LOG";
    /** 会员复购汇总 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_REPURCHASE"] = "PERMISSION_ANALYZE_CUSTOMER_REPURCHASE";
    /** 会员商品复购 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_REPURCHASE_PRODUCT_DETAIL"] = "PERMISSION_ANALYZE_CUSTOMER_REPURCHASE_PRODUCT_DETAIL";
    /** 会员消费占比 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_CONSUME_RATE"] = "PERMISSION_ANALYZE_CUSTOMER_CONSUME_RATE";
    /** 礼品卡明细 */
    IPermissonCode["PERMISSION_ANALYZE_GIFT_CARD_BALANCE_LOG"] = "PERMISSION_ANALYZE_GIFT_CARD_BALANCE_LOG";
    /** 客单分析报表 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_ORDER_PRICE"] = "PERMISSION_ANALYZE_CUSTOMER_ORDER_PRICE";
    /** 促销活动效果分析 */
    IPermissonCode["PERMISSION_ANALYZE_DISCOUNT_EFFECT"] = "PERMISSION_ANALYZE_DISCOUNT_EFFECT";
    /** 营销活动效果分析 */
    IPermissonCode["PERMISSION_ANALYZE_DISCOUNT_PROMOTION"] = "PERMISSION_ANALYZE_DISCOUNT_PROMOTION";
    /** 零销量菜品分析 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_ZERO_SALE"] = "PERMISSION_ANALYZE_PRODUCT_ZERO_SALE";
    /** 菜品关联推荐 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_RELATE_SUGGEST"] = "PERMISSION_ANALYZE_PRODUCT_RELATE_SUGGEST";
    /** 卡模板分析 */
    IPermissonCode["PERMISSION_ANALYZE_GIFT_CARD"] = "PERMISSION_ANALYZE_GIFT_CARD";
    /** 券模板分析 */
    IPermissonCode["PERMISSION_ANALYZE_TICKET"] = "PERMISSION_ANALYZE_TICKET";
    /** 券包销售统计 */
    IPermissonCode["PERMISSION_ANALYZE_TICKET_PACKAGE_SALE"] = "PERMISSION_ANALYZE_TICKET_PACKAGE_SALE";
    /** 卡券销售明细 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_CARD_ORDER_DETAIL_ANALYSIS"] = "PERMISSION_ANALYZE_BUSINESS_CARD_ORDER_DETAIL_ANALYSIS";
    /**类别销售排行 */
    IPermissonCode["PERMISSION_ANALYZE_CATEGORY_SALES_RANKING"] = "PERMISSION_ANALYZE_CATEGORY_SALES_RANKING";
    /** 套餐销售统计 */
    IPermissonCode["PERMISSION_ANALYZE_KIT_SALE_STATISTICS"] = "PERMISSION_ANALYZE_KIT_SALE_STATISTICS";
    /**餐/时段商品统计 */
    IPermissonCode["PERMISSION_ANALYZE_SESSION_PRODUCT_STATISTICS"] = "PERMISSION_ANALYZE_SESSION_PRODUCT_STATISTICS";
    /**OMS订单分析 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_PHONE_ANALYSIS"] = "PERMISSION_ANALYZE_CUSTOMER_PHONE_ANALYSIS";
    /**原材料销售消耗报表 */
    IPermissonCode["PERMISSION_ANALYZE_SALES_CONSUMPTION"] = "PERMISSION_ANALYZE_SALES_CONSUMPTION";
    /**敏感操作统计 */
    IPermissonCode["PERMISSION_ANALYZE_SENSITIVE_OPERATION"] = "PERMISSION_ANALYZE_SENSITIVE_OPERATION";
    /**商品成本毛利 */
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_COST_GROSS"] = "PERMISSION_ANALYZE_PRODUCT_COST_GROSS";
    /** 挂账明细 */
    IPermissonCode["PERMISSION_ANALYZE_SIGN_PAYMENT_DETAIL"] = "PERMISSION_ANALYZE_SIGN_PAYMENT_DETAIL";
    /** 订金/押金统计 */
    IPermissonCode["PERMISSION_ANALYZE_DOWN_PAYMENT"] = "PERMISSION_ANALYZE_DOWN_PAYMENT";
    /** 营业收款明细 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_RECEIPT_DETAIL"] = "PERMISSION_ANALYZE_BUSINESS_RECEIPT_DETAIL";
    /**财务中心-退款记录 */
    IPermissonCode["PERMISSION_MERCHANT_PAY_REFUND"] = "PERMISSION_MERCHANT_PAY_REFUND";
    /**财务中心-支付记录 */
    IPermissonCode["PERMISSION_MERCHANT_PAY_RECORD"] = "PERMISSION_MERCHANT_PAY_RECORD";
    /**财务中心-流水汇总 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_STREAM_SUMMARY"] = "PERMISSION_FRANCHISE_DISTRIBUTION_STREAM_SUMMARY";
    /**财务中心-付款记录汇总 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_PAYMENT_RECORD_SUMMARY"] = "PERMISSION_FRANCHISE_DISTRIBUTION_PAYMENT_RECORD_SUMMARY";
    /**财务中心-分账明细 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_STATISTIC"] = "PERMISSION_FRANCHISE_DISTRIBUTION_STATISTIC";
    /** 营业收款统计 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_RECEIPT_STATISTICS"] = "PERMISSION_ANALYZE_BUSINESS_RECEIPT_STATISTICS";
    /** OMS 对账日历 */
    IPermissonCode["PERMISSION_OMS_RECONCILE_CALENDAR"] = "PERMISSION_OMS_RECONCILE_CALENDAR";
    /** OMS 对账明细 */
    IPermissonCode["PERMISSION_OMS_RECONCILE_DETAIL"] = "PERMISSION_OMS_RECONCILE_DETAIL";
    /** OMS 对账结果汇总 */
    IPermissonCode["PERMISSION_OMS_RECONCILE_SUMMARY"] = "PERMISSION_OMS_RECONCILE_SUMMARY";
    /** 营业指标同环比 */
    IPermissonCode["PERMISSION_REPORT_BUSINESS_CYCLE_COMPARE"] = "PERMISSION_REPORT_BUSINESS_CYCLE_COMPARE";
    /** 收银员统计 */
    IPermissonCode["PERMISSION_ANALYZE_CASHIER_STATISTICS"] = "PERMISSION_ANALYZE_CASHIER_STATISTICS";
    /**平台小程序交易汇总 */
    IPermissonCode["PERMISSION_PLATFORM_PAY_TRADE"] = "PERMISSION_PLATFORM_PAY_TRADE";
    /** 储值分析 */
    IPermissonCode["PERMISSION_ANALYZE_DEPOSIT"] = "PERMISSION_ANALYZE_DEPOSIT";
    /**平台小程序支付记录 */
    IPermissonCode["PERMISSION_PLATFORM_PAY_RECORD"] = "PERMISSION_PLATFORM_PAY_RECORD";
    /**平台小程序退款记录 */
    IPermissonCode["PERMISSION_PLATFORM_PAY_REFUND"] = "PERMISSION_PLATFORM_PAY_REFUND";
    /**加盟分账-财务主体 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_FINANCIAL_ENTITY"] = "PERMISSION_FRANCHISE_DISTRIBUTION_FINANCIAL_ENTITY";
    /**加盟分账-款项设置 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_FEE_ITEM"] = "PERMISSION_FRANCHISE_DISTRIBUTION_FEE_ITEM";
    /**加盟分账-财务主体变更记录 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_FINANCIAL_ENTITY_CHANGE_RECORD"] = "PERMISSION_FRANCHISE_DISTRIBUTION_FINANCIAL_ENTITY_CHANGE_RECORD";
    /**加盟分账-流水明细 */
    IPermissonCode["PERMISSION_FRANCHISE_COMBINE_BALANCE_FLOW"] = "PERMISSION_FRANCHISE_COMBINE_BALANCE_FLOW";
    /**加盟分账-资金流水 */
    IPermissonCode["PERMISSION_FRANCHISE_FUND_ACCOUNT_FLOW"] = "PERMISSION_FRANCHISE_FUND_ACCOUNT_FLOW";
    /**加盟分账-记账户流水 */
    IPermissonCode["PERMISSION_FRANCHISE_RECORD_ACCOUNT_FLOW"] = "PERMISSION_FRANCHISE_RECORD_ACCOUNT_FLOW";
    /**加盟分账-付款记录 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_PAYMENT_RECORD"] = "PERMISSION_FRANCHISE_DISTRIBUTION_PAYMENT_RECORD";
    /**加盟分账-提现记录 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_WITHDRAWAL_RECORD"] = "PERMISSION_FRANCHISE_DISTRIBUTION_WITHDRAWAL_RECORD";
    /**加盟分账-分账稽查 */
    IPermissonCode["PERMISSION_FRANCHISE_BATCH_SETTLEMENT_ORDER_CHECK"] = "PERMISSION_FRANCHISE_BATCH_SETTLEMENT_ORDER_CHECK";
    /**加盟分账-储值消费分账方案 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_LEDGER"] = "PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_LEDGER";
    /**加盟分账-储值消费分账结算单 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_SETTLEMENT_FORM"] = "PERMISSION_FRANCHISE_DISTRIBUTION_STORED_VALUE_CONSUMPTION_SETTLEMENT_FORM";
    /**加盟分账-礼品卡消费分账方案 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_LEDGER"] = "PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_LEDGER";
    /**加盟分账-礼品卡消费分账结算单 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_SETTLEMENT_FORM"] = "PERMISSION_FRANCHISE_DISTRIBUTION_GIFT_CARD_CONSUMPTION_SETTLEMENT_FORM";
    /**加盟分账-券核销分账方案 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_LEDGER"] = "PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_LEDGER";
    /**加盟分账-券核销分账结算单 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_SETTLEMENT_FORM"] = "PERMISSION_FRANCHISE_DISTRIBUTION_VOUCHER_VERIFICATION_SETTLEMENT_FORM";
    /**加盟分账-总部分账方案 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_LEDGER"] = "PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_LEDGER";
    /**加盟分账-总部费用单 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_EXPENSE"] = "PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_EXPENSE";
    /**加盟分账-总部分账结算单 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_SETTLEMENT_FORM"] = "PERMISSION_FRANCHISE_DISTRIBUTION_HEADQUARTERS_SETTLEMENT_FORM";
    /**加盟分账-门店分账方案 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_LEDGER"] = "PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_LEDGER";
    /**加盟分账-门店费用单 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_EXPENSE"] = "PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_EXPENSE";
    /**加盟分账-门店分账结算单 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_SETTLEMENT_FORM"] = "PERMISSION_FRANCHISE_DISTRIBUTION_LOCATION_SETTLEMENT_FORM";
    /**加盟分账-自定义分账方案 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_LEDGER"] = "PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_LEDGER";
    /**加盟分账-自定义分账结算单 */
    IPermissonCode["PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_SETTLEMENT_FORM"] = "PERMISSION_FRANCHISE_DISTRIBUTION_CUSTOMIZED_SETTLEMENT_FORM";
    /**加盟分账-资金参数 */
    IPermissonCode["PERMISSION_FRANCHISE_FINANCE_SETTING"] = "PERMISSION_FRANCHISE_FINANCE_SETTING";
    /** 营业收款稽核 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_PAY_VERIFY"] = "PERMISSION_ANALYZE_BUSINESS_PAY_VERIFY";
    /** 交班统计 */
    IPermissonCode["PERMISSION_ANALYZE_SHIFT_HANDOVER_STATISTICS"] = "PERMISSION_ANALYZE_SHIFT_HANDOVER_STATISTICS";
    /** 商户支付-交易汇总 */
    IPermissonCode["PERMISSION_MERCHANT_PAY_TRADE"] = "PERMISSION_MERCHANT_PAY_TRADE";
    /** KDS设置 */
    IPermissonCode["PERMISSION_SETTING_WIN_KDS"] = "PERMISSION_SETTING_WIN_KDS";
    /** 用户业绩 */
    IPermissonCode["PERMISSION_ANALYZE_CUSTOMER_PERFORMANCE"] = "PERMISSION_ANALYZE_CUSTOMER_PERFORMANCE";
    /** 营业概览 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_OVERVIEW"] = "PERMISSION_ANALYZE_BUSINESS_OVERVIEW";
    /** 排队设置 */
    IPermissonCode["PERMISSION_SETTING_SHIPPING_TAKE_REQUIRED_QUEUE"] = "PERMISSION_SETTING_SHIPPING_TAKE_REQUIRED_QUEUE";
    /** 财务中心-渠道配置 */
    IPermissonCode["PERMISSION_MERCHANT_PAY_CHANNEL_CONFIG"] = "PERMISSION_MERCHANT_PAY_CHANNEL_CONFIG";
    /** 财务中心-我的商户 */
    IPermissonCode["PERMISSION_MERCHANT_PAY_MY_MERCHANT"] = "PERMISSION_MERCHANT_PAY_MY_MERCHANT";
    /** 财务中心-我的商户(管理) */
    IPermissonCode["PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_MGR"] = "PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_MGR";
    /** 财务中心-我的商户(分组) */
    IPermissonCode["PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_GROUP"] = "PERMISSION_MERCHANT_PAY_MY_MERCHANT_SUB_GROUP";
    /** 财务中心-我的应用 */
    IPermissonCode["PERMISSION_MERCHANT_PAY_MY_APP"] = "PERMISSION_MERCHANT_PAY_MY_APP";
    /** 财务中心-开票设置 */
    IPermissonCode["PERMISSION_INVOICE_SETTING"] = "PERMISSION_INVOICE_SETTING";
    /** 财务中心-门店设置 */
    IPermissonCode["PERMISSION_INVOICE_LOCATION_SETTING"] = "PERMISSION_INVOICE_LOCATION_SETTING";
    /** 财务中心-开票主体 */
    IPermissonCode["PERMISSION_INVOICE_BODY"] = "PERMISSION_INVOICE_BODY";
    /** 品牌管理 */
    IPermissonCode["PERMISSION_SETTING_VENDOR_MANAGER"] = "PERMISSION_SETTING_VENDOR_MANAGER";
    /** 素材库操作 */
    IPermissonCode["PERMISSION_SETTING_FILES"] = "PERMISSION_SETTING_FILES";
    /** 台位管理 */
    IPermissonCode["PERMISSION_SETTING_SHIPPING_TABLE"] = "PERMISSION_SETTING_SHIPPING_TABLE";
    /** 设备管理 */
    IPermissonCode["PERMISSION_POS_WEB_POS_TERMINAL"] = "PERMISSION_POS_WEB_POS_TERMINAL";
    /** TV屏设备 */
    IPermissonCode["PERMISSION_TV_DEVICE"] = "PERMISSION_TV_DEVICE";
    /** KDS设备管理 */
    IPermissonCode["PERMISSION_KDS_DEVICE"] = "PERMISSION_KDS_DEVICE";
    /** 打印机管理 */
    IPermissonCode["PERMISSION_PRINT_DEVICE"] = "PERMISSION_PRINT_DEVICE";
    /** 云音响管理 */
    IPermissonCode["PERMISSION_CLOUD_SPEAKER"] = "PERMISSION_CLOUD_SPEAKER";
    /** 设备分组管理 */
    IPermissonCode["PERMISSION_CLOUD_SPEAKER_GROUP"] = "PERMISSION_DEVICE_GROUP";
    /** 语音播报规则 */
    IPermissonCode["PERMISSION_CLOUD_SPEAKER_RULE"] = "PERMISSION_VOICE_BROADCAST_RULE";
    /** 门店设备分组详情 */
    IPermissonCode["PERMISSION_DEVICE_GROUP_DETAIL"] = "PERMISSION_DEVICE_GROUP_DETAIL";
    /** 门店语音播报规则详情 */
    IPermissonCode["PERMISSION_VOICE_BROADCAST_DETAIL"] = "PERMISSION_VOICE_BROADCAST_DETAIL";
    /** 硬件管理 */
    IPermissonCode["PERMISSION_POS_WEB_HARDWARE_SETTING"] = "PERMISSION_POS_WEB_HARDWARE_SETTING";
    /**店铺设置 */
    IPermissonCode["PERMISSION_SETTING_MERCHANT_SETTING"] = "PERMISSION_SETTING_MERCHANT_SETTING";
    /**支付方式设置 */
    IPermissonCode["PERMISSION_SETTING_PAY"] = "PERMISSION_SETTING_PAY";
    /**小程序分析 */
    IPermissonCode["PERMISSION_ANALYZE_CONSUMPTION_ANALYSIS"] = "PERMISSION_ANALYZE_CONSUMPTION_ANALYSIS";
    /** 积分分析 */
    IPermissonCode["PERMISSION_ANALYZE_POINT"] = "PERMISSION_ANALYZE_POINT";
    /** 权益卡分析 */
    IPermissonCode["PERMISSION_ANALYZE_RIGHT_CARD"] = "PERMISSION_ANALYZE_RIGHT_CARD";
    /**商城流量概况 */
    IPermissonCode["PERMISSION_WESTORE_TRAFFIC_OVERVIEW"] = "PERMISSION_WESTORE_TRAFFIC_OVERVIEW";
    /**美团点评券 */
    IPermissonCode["PERMISSION_PROMOTION_VIRTUAL_TICKET_MT"] = "PERMISSION_PROMOTION_VIRTUAL_TICKET_MT";
    /** 支付宝门店 */
    IPermissonCode["PERMISSION_PROMOTION_ALIPAY_LOCATION"] = "PERMISSION_PROMOTION_ALIPAY_LOCATION";
    /** 支付宝神券 */
    IPermissonCode["PERMISSION_PROMOTION_VIRTUAL_TICKET_ALIPAY"] = "PERMISSION_PROMOTION_VIRTUAL_TICKET_ALIPAY";
    /**抖音券 */
    IPermissonCode["PERMISSION_PROMOTION_VIRTUAL_TICKET_DY"] = "PERMISSION_PROMOTION_VIRTUAL_TICKET_DY";
    /** 抖音会员通 */
    IPermissonCode["PERMISSION_DY_MEMBER_PASS"] = "PERMISSION_DY_MEMBER_PASS";
    /** 零售会员通：查看与配置 */
    IPermissonCode["PERMISSION_RETAIL_MEMBER_PASS"] = "PERMISSION_RETAIL_MEMBER_PASS";
    /**口碑券 */
    IPermissonCode["PERMISSION_PROMOTION_VIRTUAL_TICKET_KOU_BEI"] = "PERMISSION_PROMOTION_VIRTUAL_TICKET_KOU_BEI";
    /**快手券 */
    IPermissonCode["PERMISSION_PROMOTION_VIRTUAL_TICKET_KS"] = "PERMISSION_PROMOTION_VIRTUAL_TICKET_KS";
    /** 辅屏设置 */
    IPermissonCode["PERMISSION_POS_SECOND_DISPLAY_SETTING"] = "PERMISSION_POS_SECOND_DISPLAY_SETTING";
    /** 轮播图 */
    IPermissonCode["PERMISSION_POS_WEB_POS_SECOND_DISPLAY_SETTING"] = "PERMISSION_POS_WEB_POS_SECOND_DISPLAY_SETTING";
    /** 寄存单 */
    IPermissonCode["PERMISSION_STORAGE_ORDER"] = "PERMISSION_STORAGE_ORDER";
    /** 订金/押金 */
    IPermissonCode["PERMISSION_DOWN_PAYMENT"] = "PERMISSION_DOWN_PAYMENT";
    /** 订单评价 */
    IPermissonCode["PERMISSION_ORDER_EVALUATION"] = "PERMISSION_ORDER_EVALUATION";
    /** 评价分析 */
    IPermissonCode["PERMISSION_ORDER_EVALUATION_ANALYZE"] = "PERMISSION_ORDER_EVALUATION_ANALYZE";
    /** 快递模板 */
    IPermissonCode["PERMISSION_SETTING_EXPRESS_TMPL"] = "PERMISSION_SETTING_EXPRESS_TMPL";
    /** 生产人员生产汇总报表 */
    // PERMISSION_STOCK_PRODUCE_OPERATOR_PRODUCE_SUMMARY = 'PERMISSION_STOCK_PRODUCE_OPERATOR_PRODUCE_SUMMARY',
    /** 群欢迎语 */
    IPermissonCode["PERMISSION_WECOM_GROUP_GREET"] = "PERMISSION_WECOM_GROUP_GREET";
    /** 堂食设置 */
    IPermissonCode["PERMISSION_OPERATE_SETTING_DINING_IN"] = "PERMISSION_OPERATE_SETTING_DINING_IN";
    /** 自提设置 */
    IPermissonCode["PERMISSION_SETTING_SHIPPING_SELF_AND_TAKE_OUT"] = "PERMISSION_SETTING_SHIPPING_SELF_AND_TAKE_OUT";
    /** 外卖设置 */
    IPermissonCode["PERMISSION_OPERATE_SETTING_TAKE_OUT"] = "PERMISSION_OPERATE_SETTING_TAKE_OUT";
    /** 团餐自提 */
    IPermissonCode["PERMISSION_SETTING_SHIPPING_GROUP_MEAL"] = "PERMISSION_SETTING_SHIPPING_GROUP_MEAL";
    /** 团餐外卖 */
    IPermissonCode["PERMISSION_OPERATE_SETTING_GROUP_MEAL_TAKE_OUT"] = "PERMISSION_OPERATE_SETTING_GROUP_MEAL_TAKE_OUT";
    /** 客户群发 */
    IPermissonCode["PERMISSION_WECOM_CUSTOMER_GROUP_SEND"] = "PERMISSION_WECOM_CUSTOMER_GROUP_SEND";
    /** 社群群发 */
    IPermissonCode["PERMISSION_WECOM_GROUP_GROUP_SEND"] = "PERMISSION_WECOM_GROUP_GROUP_SEND";
    /** 系统推荐群体 */
    IPermissonCode["PERMISSION_CUSTOMER_SYSTEM_TAG"] = "PERMISSION_CUSTOMER_SYSTEM_TAG";
    /** 自定义群体 */
    IPermissonCode["PERMISSION_CUSTOMER_CONDITION_TAG"] = "PERMISSION_CUSTOMER_CONDITION_TAG";
    /** 客户标签 */
    IPermissonCode["PERMISSION_CUSTOMER_MANUAL_TAG"] = "PERMISSION_CUSTOMER_MANUAL_TAG";
    /** 定时赠券 */
    IPermissonCode["PERMISSION_PROMOTION_TIMED_GIFT_TICKET"] = "PERMISSION_PROMOTION_TIMED_GIFT_TICKET";
    /** 群发助手 */
    IPermissonCode["PERMISSION_WECOM_GROUP_SEND_ASSISANT"] = "PERMISSION_WECOM_GROUP_SEND_ASSISANT";
    /** 素材库 */
    IPermissonCode["PERMISSION_WECOM_MATERIAL"] = "PERMISSION_WECOM_MATERIAL";
    /** 客户列表 */
    IPermissonCode["PERMISSION_WECOM_CUSTOMER"] = "PERMISSION_WECOM_CUSTOMER";
    /** 接单异常 */
    IPermissonCode["PERMISSION_EXCEPTION_ORDER_ACCEPT"] = "PERMISSION_EXCEPTION_ORDER_ACCEPT";
    /** 配送异常 */
    IPermissonCode["PERMISSION_EXCEPTION_ORDER_FULFILL"] = "PERMISSION_EXCEPTION_ORDER_FULFILL";
    /** 支付异常 */
    IPermissonCode["PERMISSION_EXCEPTION_ORDER_PAY"] = "PERMISSION_EXCEPTION_ORDER_PAY";
    /**储值异常 */
    IPermissonCode["PERMISSION_EXCEPTION_DEPOSIT_ORDER"] = "PERMISSION_EXCEPTION_DEPOSIT_ORDER";
    /** 客户群 */
    IPermissonCode["PERMISSION_WECOM_CUSTOMER_GROUP"] = "PERMISSION_WECOM_CUSTOMER_GROUP";
    /** 群主管理 */
    IPermissonCode["PERMISSION_WECOM_GROUP_OWNER"] = "PERMISSION_WECOM_GROUP_OWNER";
    /** 企业管理 */
    IPermissonCode["PERMISSION_ENTERPRISE"] = "PERMISSION_ENTERPRISE";
    /** 个人挂账管理  */
    IPermissonCode["PERMISSION_PERSON_ARREARS"] = "PERMISSION_PERSON_ARREARS";
    /**商品管理-商品类别 */
    IPermissonCode["PERMISSION_PRODUCT_TYPE"] = "PERMISSION_PRODUCT_TYPE";
    /**商品管理-商品系列 */
    IPermissonCode["PERMISSION_PRODUCT_COLLECT"] = "PERMISSION_PRODUCT_COLLECT";
    /**商品管理-收入科目 */
    IPermissonCode["PERMISSION_PRODUCT_INCOME_SUBJECT"] = "PERMISSION_PRODUCT_INCOME_SUBJECT";
    /**商品管理-门店商品类别 */
    IPermissonCode["PERMISSION_PRODUCT_TYPE_LOCATION"] = "PERMISSION_PRODUCT_TYPE_LOCATION";
    /**商品管理-单位 */
    IPermissonCode["PERMISSION_PRODUCT_UNIT"] = "PERMISSION_PRODUCT_UNIT";
    /**商品管理-门店菜品属性-单位管理 */
    IPermissonCode["PERMISSION_PRODUCT_UNIT_LOCATION_UNIT"] = "PERMISSION_PRODUCT_UNIT_LOCATION_UNIT";
    /**商品管理-属性 */
    IPermissonCode["PERMISSION_PRODUCT_OPTION"] = "PERMISSION_PRODUCT_OPTION";
    /**商品管理-规格 */
    IPermissonCode["PERMISSION_PRODUCT_OPTION_VARAINT"] = "PERMISSION_PRODUCT_OPTION_VARAINT";
    /**商品管理-门店规格 */
    IPermissonCode["PERMISSION_PRODUCT_OPTION_LOCATION_VARAINT"] = "PERMISSION_PRODUCT_OPTION_LOCATION_VARAINT";
    /**商品管理-做法管理 */
    IPermissonCode["PERMISSION_PRODUCT_OPTION_METHOD"] = "PERMISSION_PRODUCT_OPTION_METHOD";
    /**商品管理-加料管理 */
    IPermissonCode["PERMISSION_PRODUCT_OPTION_ADD"] = "PERMISSION_PRODUCT_OPTION_ADD";
    /**商品管理-属性库 */
    IPermissonCode["PERMISSION_PRODUCT_OPTION_LOCATION"] = "PERMISSION_PRODUCT_OPTION_LOCATION";
    /**商品管理-门店做法管理 */
    IPermissonCode["PERMISSION_PRODUCT_OPTION_LOCATION_METHOD"] = "PERMISSION_PRODUCT_OPTION_LOCATION_METHOD";
    /**商品管理-门店加料管理 */
    IPermissonCode["PERMISSION_PRODUCT_OPTION_LOCATION_ADD"] = "PERMISSION_PRODUCT_OPTION_LOCATION_ADD";
    /** 商品管理-门店商品 */
    IPermissonCode["PERMISSION_PRODUCT_LOCATION"] = "PERMISSION_PRODUCT_LOCATION";
    /** 商品管理-门店套餐商品 */
    IPermissonCode["PERMISSION_PRODUCT_KIT_LOCATION"] = "PERMISSION_PRODUCT_KIT_LOCATION";
    /**商品管理-角标 */
    IPermissonCode["PERMISSION_PRODUCT_CORNER_MARK"] = "PERMISSION_PRODUCT_CORNER_MARK";
    /**商品管理-包装盒 */
    IPermissonCode["PERMISSION_PACKAGE_BOX"] = "PERMISSION_PACKAGE_BOX";
    /**商品管理-商品时段 */
    IPermissonCode["PERMISSION_PRODUCT_TIME_PERIOD"] = "PERMISSION_PRODUCT_TIME_PERIOD";
    /** 基础档案-时段菜单（权限中心 code_key 去除作用域前缀后的值） */
    IPermissonCode["PERMISSION_PRODUCT_TIME_MENUY"] = "PERMISSION_PRODUCT_TIME_MENUY";
    /** 门店菜品管理-门店时段菜单（总部、门店共用） */
    IPermissonCode["PERMISSION_PRODUCT_TIME_MENUY_LOCATION"] = "PERMISSION_PRODUCT_TIME_MENUY_LOCATION";
    /** 必点菜 */
    IPermissonCode["PERMISSION_PRODUCT_MUST_ORDER"] = "PERMISSION_PRODUCT_MUST_ORDER";
    /**商品管理-库存 */
    IPermissonCode["PERMISSION_PRODUCT_INVENTORY"] = "PERMISSION_PRODUCT_INVENTORY";
    /**商品管理-库存变动 */
    IPermissonCode["PERMISSION_PRODUCT_INVENTORY_LOG"] = "PERMISSION_PRODUCT_INVENTORY_LOG";
    /**商品管理-库存同步 */
    IPermissonCode["PERMISSION_PRODUCT_INVENTORY_SYNC"] = "PERMISSION_PRODUCT_INVENTORY_SYNC";
    /**商品管理-商品排序 */
    IPermissonCode["PERMISSION_PRODUCT_SORT"] = "PERMISSION_PRODUCT_SORT";
    /**商品管理-计划库存 */
    IPermissonCode["PERMISSION_PLAN_INVENTORY"] = "PERMISSION_PLAN_INVENTORY";
    /** 员工管理 */
    IPermissonCode["PERMISSION_WECOM_STAFF_MGR"] = "PERMISSION_WECOM_STAFF_MGR";
    /** 员工接口管理 */
    IPermissonCode["PERMISSION_WECOM_STAFF_LICENSE_MGR"] = "PERMISSION_WECOM_STAFF_LICENSE_MGR";
    /** 企微角色管理 */
    IPermissonCode["PERMISSION_WECOM_ROLE_MGR"] = "PERMISSION_WECOM_ROLE_MGR";
    IPermissonCode["PERMISSION_SETTING_ACCOUNT"] = "PERMISSION_SETTING_ACCOUNT";
    /**标准商品 */
    IPermissonCode["PERMISSION_PRODUCT"] = "PERMISSION_PRODUCT";
    /** 商城商品 */
    IPermissonCode["PERMISSION_PRODUCT_SHOP"] = "PERMISSION_PRODUCT_SHOP";
    /** 订单	堂食订单 */
    IPermissonCode["PERMISSION_ORDER"] = "PERMISSION_ORDER";
    /** 订单	堂食订单 */
    IPermissonCode["PERMISSION_DINE_IN_ORDER"] = "PERMISSION_ORDER";
    /** 订单	自提配送订单 */
    IPermissonCode["PERMISSION_ORDER_SELF_AND_DELIVER"] = "PERMISSION_ORDER_SELF_AND_DELIVER";
    /** 订单	三方订单 */
    IPermissonCode["PERMISSION_ORDER_THIRD_PLATFORM"] = "PERMISSION_ORDER_THIRD_PLATFORM";
    /** 订单	商品预约订单 */
    IPermissonCode["PERMISSION_ORDER_PRODUCT_RESERVE"] = "PERMISSION_ORDER_PRODUCT_RESERVE";
    /** 订单	商城订单 */
    IPermissonCode["PERMISSION_ORDER_SHOP"] = "PERMISSION_ORDER_SHOP";
    /** 订单	扫码订单 */
    IPermissonCode["PERMISSION_ORDER_PRODUCT_SCAN_CODE"] = "PERMISSION_ORDER_PRODUCT_SCAN_CODE";
    /** 卡券订单 */
    IPermissonCode["PERMISSION_CARD_ORDER"] = "PERMISSION_CARD_ORDER";
    /** 异常订单 */
    IPermissonCode["PERMISSION_EXCEPTION_ORDER"] = "PERMISSION_EXCEPTION_ORDER";
    /** 卡券售后订单 */
    IPermissonCode["PERMISSION_AFTER_SALE_CARD_ORDER"] = "PERMISSION_AFTER_SALE_CARD_ORDER";
    /** 客户管理 */
    IPermissonCode["PERMISSION_CUSTOMER"] = "PERMISSION_CUSTOMER";
    /** 企微应用 */
    IPermissonCode["PERMISSION_WECOM_APP"] = "PERMISSION_WECOM_APP";
    // 增值服务 短信 (权益账户)
    IPermissonCode["PERMISSION_SETTING_VALIE_ADD"] = "PERMISSION_SETTING_VALIE_ADD";
    // 门店账号设置
    IPermissonCode["PERMISSION_SETTING_LOCATION_ACCOUNT_SETTING"] = "PERMISSION_SETTING_LOCATION_ACCOUNT_SETTING";
    /** 储值体系-会员卡参数 */
    IPermissonCode["PERMISSION_CUSTOMER_ASSET_DEPOSIT_MGR"] = "PERMISSION_CUSTOMER_ASSET_DEPOSIT_MGR";
    /** 储值体系-退余额管理 */
    IPermissonCode["PERMISSION_CUSTOMER_BALANCE_REFUND_ORDER"] = "PERMISSION_CUSTOMER_BALANCE_REFUND_ORDER";
    /** 积分体系 */
    IPermissonCode["PERMISSION_CUSTOMER_ASSET_POINT_MGR"] = "PERMISSION_CUSTOMER_ASSET_POINT_MGR";
    /** 叫号设置 */
    IPermissonCode["PERMISSION_SETTING_CALL_NUMBER"] = "PERMISSION_SETTING_CALL_NUMBER";
    //门店设置-通用设置
    IPermissonCode["PERMISSION_SETTING_SHIPPING_COMMON"] = "PERMISSION_SETTING_SHIPPING_COMMON";
    /** 渠道活码 */
    IPermissonCode["PERMISSION_WECOM_CUSTOMER_CHANNEL_CODE"] = "PERMISSION_WECOM_CUSTOMER_CHANNEL_CODE";
    /** 社群活码 */
    IPermissonCode["PERMISSION_WECOM_GROUP_CHANNEL_CODE"] = "PERMISSION_WECOM_GROUP_CHANNEL_CODE";
    /** 会员卡-卡类型 */
    IPermissonCode["PERMISSION_CUSTOMER_CARD_TYPE"] = "PERMISSION_CUSTOMER_CARD_TYPE";
    /** lbs加好友 */
    IPermissonCode["PERMISSION_WECOM_LBS_FRIEND"] = "PERMISSION_WECOM_LBS_FRIEND";
    /** lbs引流入群 */
    IPermissonCode["PERMISSION_WECOM_LBS_GROUP"] = "PERMISSION_WECOM_LBS_GROUP";
    /** 会员卡列表 */
    IPermissonCode["PERMISSION_CUSTOMER_CARD_LIST"] = "PERMISSION_CUSTOMER_CARD_LIST";
    /** 数据定义 */
    IPermissonCode["PERMISSION_CUSTOMER_CUSTOM_CONDITION"] = "PERMISSION_CUSTOMER_CUSTOM_CONDITION";
    /** 等级会员卡 */
    IPermissonCode["PERMISSION_CUSTOMER_LEVEL_MEMBER_CARD"] = "PERMISSION_CUSTOMER_LEVEL_MEMBER_CARD";
    /** 渠道配送-渠道 */
    IPermissonCode["PERMISSION_AGGREGATE_TRANSFER_CHANNEL"] = "PERMISSION_AGGREGATE_TRANSFER_CHANNEL";
    /** 渠道配送-门店 */
    IPermissonCode["PERMISSION_AGGREGATE_TRANSFER_RULE"] = "PERMISSION_AGGREGATE_TRANSFER_RULE";
    /**门店管理 */
    IPermissonCode["PERMISSION_SETTING_LOCATION"] = "PERMISSION_SETTING_LOCATION";
    /** 门店财务设置 */
    IPermissonCode["PERMISSION_FINANCE_SUBJECT_LOCATION_CONFIG"] = "PERMISSION_FINANCE_SUBJECT_LOCATION_CONFIG";
    /**门店管理-标签 */
    IPermissonCode["PERMISSION_SETTING_LOCATION_TAG"] = "PERMISSION_SETTING_LOCATION_TAG";
    /** 出品部门-总部 */
    IPermissonCode["PERMISSION_PRODUCT_TAG_HEADQUARTERS"] = "PERMISSION_PRODUCT_TAG_HEADQUARTERS";
    /** 出品部门-门店 */
    IPermissonCode["PERMISSION_PRODUCT_TAG_LOCATION"] = "PERMISSION_PRODUCT_TAG_LOCATION";
    /** 商品打印配置 */
    IPermissonCode["PERMISSION_PRODUCT_PRINT_CONFIGURATION"] = "PERMISSION_PRODUCT_PRINT_CONFIGURATION";
    /** 会员权益库 */
    IPermissonCode["PERMISSION_CUSTOMER_MEMBER_RIGHT"] = "PERMISSION_CUSTOMER_MEMBER_RIGHT";
    /** 员工角色 */
    IPermissonCode["PERMISSION_POS_WEB_ROLE"] = "PERMISSION_POS_WEB_ROLE";
    /**预储值 */
    IPermissonCode["PERMISSION_PRE_DEPOSITS"] = "PERMISSION_PRE_DEPOSITS";
    /** 会员价 */
    IPermissonCode["PERMISSION_MEMBER_PRICE"] = "PERMISSION_MEMBER_PRICE";
    /** 员工管理 */
    IPermissonCode["PERMISSION_POS_WEB_STAFF"] = "PERMISSION_POS_WEB_STAFF";
    /** 礼品卡模版 */
    IPermissonCode["PERMISSION_PROMOTION_GIFT_CARD_TMPL"] = "PERMISSION_PROMOTION_GIFT_CARD_TMPL";
    /** 权益卡 */
    IPermissonCode["PERMISSION_PROMOTION_RIGHT_CARD"] = "PERMISSION_PROMOTION_RIGHT_CARD";
    /** 券包 */
    IPermissonCode["PERMISSION_DISCOUNT_TICKET_PACK"] = "PERMISSION_DISCOUNT_TICKET_PACK";
    /** 备注管理 */
    IPermissonCode["PERMISSION_POS_WEB_MEMO"] = "PERMISSION_POS_WEB_MEMO";
    IPermissonCode["PERMISSION_PROMOTION_GIFT_CARD"] = "PERMISSION_PROMOTION_GIFT_CARD";
    IPermissonCode["PERMISSION_PROMOTION_GIFT_CARD_MAKE_ORDER"] = "PERMISSION_PROMOTION_GIFT_CARD_MAKE_ORDER";
    IPermissonCode["PERMISSION_PROMOTION_GIFT_CARD_INFO"] = "PERMISSION_PROMOTION_GIFT_CARD_INFO";
    IPermissonCode["PERMISSION_PROMOTION_GIFT_CARD_THEME"] = "PERMISSION_PROMOTION_GIFT_CARD_THEME";
    IPermissonCode["PERMISSION_PROMOTION_COLLECT_STAMP"] = "PERMISSION_PROMOTION_COLLECT_STAMP";
    IPermissonCode["PERMISSION_DEPOSIT_PAY_DISCOUNT_RANGE"] = "PERMISSION_DEPOSIT_PAY_DISCOUNT_RANGE";
    IPermissonCode["PERMISSION_DISCOUNT_TICKET"] = "PERMISSION_DISCOUNT_TICKET";
    IPermissonCode["PERMISSION_DISCOUNT_GET_TICKET_ACTIVITY"] = "PERMISSION_DISCOUNT_GET_TICKET_ACTIVITY";
    IPermissonCode["PERMISSION_PROMOTION_POPUP_TICKET_MGR"] = "PERMISSION_PROMOTION_POPUP_TICKET_MGR";
    IPermissonCode["PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY"] = "PERMISSION_PROMOTION_QUESTIONNAIRE_SURVEY";
    IPermissonCode["PERMISSION_APP_GIFT_GET_CARD"] = "PERMISSION_APP_GIFT_GET_CARD";
    IPermissonCode["PERMISSION_PROMOTION_CUSTOMER_FISSION"] = "PERMISSION_PROMOTION_CUSTOMER_FISSION";
    IPermissonCode["PERMISSION_DISCOUNT_NEW_CUSTOMER_EXCLUSIVE"] = "PERMISSION_DISCOUNT_NEW_CUSTOMER_EXCLUSIVE";
    IPermissonCode["PERMISSION_DISCOUNT_GROUP_RELAY"] = "PERMISSION_DISCOUNT_GROUP_RELAY";
    IPermissonCode["PERMISSION_DISCOUNT_FULL_REDUCE"] = "PERMISSION_DISCOUNT_FULL_REDUCE";
    IPermissonCode["PERMISSION_APP_LIMIT_TIME_DISCOUNT"] = "PERMISSION_APP_LIMIT_TIME_DISCOUNT";
    IPermissonCode["PERMISSION_SECOND_HALF_DISCOUNT"] = "PERMISSION_APP_SECOND_HALF_DISCOUNT";
    IPermissonCode["PERMISSION_PROMOTION_GROUP_BUYING"] = "PERMISSION_PROMOTION_GROUP_BUYING";
    IPermissonCode["PERMISSION_DISCOUNT_FULL_GIFT"] = "PERMISSION_DISCOUNT_FULL_GIFT";
    IPermissonCode["PERMISSION_DISCOUNT_MARK_UP_PURCHASE"] = "PERMISSION_DISCOUNT_MARK_UP_PURCHASE";
    IPermissonCode["PERMISSION_DISCOUNT_FREIGHT_REDUCE"] = "PERMISSION_DISCOUNT_FREIGHT_REDUCE";
    IPermissonCode["PERMISSION_DISCOUNT_ANY_CHOICE"] = "PERMISSION_DISCOUNT_ANY_CHOICE";
    IPermissonCode["PERMISSION_DISCOUNT_RANDOM_REDUCE"] = "PERMISSION_DISCOUNT_RANDOM_REDUCE";
    IPermissonCode["PERMISSION_APP_GIFT_CONSUME"] = "PERMISSION_APP_GIFT_CONSUME";
    IPermissonCode["PERMISSION_DISCOUNT_SCAN_CODE_PAY"] = "PERMISSION_DISCOUNT_SCAN_CODE_PAY";
    IPermissonCode["PERMISSION_PROMOTION_RECOMMEND_PRODUCT_ACTIVITY"] = "PERMISSION_PROMOTION_RECOMMEND_PRODUCT_ACTIVITY";
    IPermissonCode["PERMISSION_DISCOUNT_RECOMMEND_PURCHASE"] = "PERMISSION_DISCOUNT_RECOMMEND_PURCHASE";
    IPermissonCode["PERMISSION_APP_GIFT_DEPOSIT"] = "PERMISSION_APP_GIFT_DEPOSIT";
    IPermissonCode["PERMISSION_APP_GIFT_REVIEW"] = "PERMISSION_APP_GIFT_REVIEW";
    IPermissonCode["PERMISSION_APP_GIFT_LEVEL_UP"] = "PERMISSION_APP_GIFT_LEVEL_UP";
    IPermissonCode["PERMISSION_PROMOTION_GIFT_SIGN_IN"] = "PERMISSION_PROMOTION_GIFT_SIGN_IN";
    IPermissonCode["PERMISSION_PROMOTION_POINT_EXCHANGE"] = "PERMISSION_PROMOTION_POINT_EXCHANGE";
    IPermissonCode["PERMISSION_PROMOTION_POINT_EXCHANGE_ACTIVITY"] = "PERMISSION_PROMOTION_POINT_EXCHANGE_ACTIVITY";
    IPermissonCode["PERMISSION_PROMOTION_POINT_EXCHANGE_LOG"] = "PERMISSION_PROMOTION_POINT_EXCHANGE_LOG";
    IPermissonCode["PERMISSION_PROMOTION_POINT_EXCHANGE_PROPERTY"] = "PERMISSION_PROMOTION_POINT_EXCHANGE_PROPERTY";
    IPermissonCode["PERMISSION_PROMOTION_AD_MGR"] = "PERMISSION_PROMOTION_AD_MGR";
    IPermissonCode["PERMISSION_PROMOTION_SMS_GROUP_SEND"] = "PERMISSION_PROMOTION_SMS_GROUP_SEND";
    IPermissonCode["PERMISSION_APP_GIFT_BIRTHDAY"] = "PERMISSION_APP_GIFT_BIRTHDAY";
    IPermissonCode["PERMISSION_GIFT_LUCKY_DRAW"] = "PERMISSION_GIFT_LUCKY_DRAW";
    IPermissonCode["PERMISSION_DISCOUNT_TASK_ACTIVITY"] = "PERMISSION_DISCOUNT_TASK_ACTIVITY";
    IPermissonCode["PERMISSION_PROMOTION_FUN_GUESS"] = "PERMISSION_PROMOTION_FUN_GUESS";
    IPermissonCode["PERMISSION_PROMOTION_FUN_MATCH"] = "PERMISSION_PROMOTION_FUN_MATCH";
    IPermissonCode["PERMISSION_PROMOTION_ACTIVE_MANAGER"] = "PERMISSION_PROMOTION_ACTIVE_MANAGER";
    /** 促销活动管理 */
    IPermissonCode["PARENT_PERMISSION_PROMOTION_EVENT_MANAGER"] = "PARENT_PERMISSION_PROMOTION_EVENT_MANAGER";
    /** 打印顺序 */
    IPermissonCode["PERMISSION_POS_WEB_PRINT_ORDER"] = "PERMISSION_POS_WEB_PRINT_ORDER";
    /** 销售员 */
    IPermissonCode["PERMISSION_POS_SALESMAN"] = "PERMISSION_POS_SALESMAN";
    /** 营销管理-共享互斥 */
    IPermissonCode["PERMISSION_PROMOTION_EXCLUSIVE_SHARE"] = "PERMISSION_PROMOTION_EXCLUSIVE_SHARE";
    /** 折扣减免 */
    IPermissonCode["PERMISSION_POS_WEB_FAST_DISCOUNT"] = "PERMISSION_POS_WEB_FAST_DISCOUNT";
    /** 售后订单 */
    IPermissonCode["PERMISSION_AFTER_SALE_ORDER"] = "PERMISSION_AFTER_SALE_ORDER";
    IPermissonCode["PERMISSION_SETTING_PRINT_MERCHANR"] = "PERMISSION_SETTING_PRINT_MERCHANR";
    IPermissonCode["PERMISSION_SETTING_PRINT_LOCATION"] = "PERMISSION_SETTING_PRINT_LOCATION";
    IPermissonCode["PERMISSION_SETTING_AGREEMENT"] = "PERMISSION_SETTING_AGREEMENT";
    IPermissonCode["PERMISSION_WESTORE_WECHAT_MP_AUTH_SETTING"] = "PERMISSION_WESTORE_WECHAT_MP_AUTH_SETTING";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_FEATURE"] = "PERMISSION_WESTORE_SHOP_DECORATION_FEATURE";
    /** 店铺装修 */
    IPermissonCode["PERMISSION_WESTORE_DECORATION"] = "PERMISSION_WESTORE_DECORATION";
    IPermissonCode["PERMISSION_WESTORE_ADVICE_FEEDBACK_LIST"] = "PERMISSION_WESTORE_ADVICE_FEEDBACK_LIST";
    IPermissonCode["PERMISSION_WESTORE_ADVICE_FEEDBACK_SET"] = "PERMISSION_WESTORE_ADVICE_FEEDBACK_SET";
    IPermissonCode["PERMISSION_WESTORE_WECHAT_MP_OFFICIAL_ACCOUNT"] = "PERMISSION_WESTORE_WECHAT_MP_OFFICIAL_ACCOUNT";
    IPermissonCode["PERMISSION_SETTING_EXPRESS_SHOP_SETTING"] = "PERMISSION_SETTING_EXPRESS_SHOP_SETTING";
    /** 总部收银 */
    IPermissonCode["PERMISSION_POS_WEB_CASHIER_PRINT_RULE"] = "PERMISSION_POS_WEB_CASHIER_PRINT_RULE";
    /** 总部后厨 */
    IPermissonCode["PERMISSION_POS_WEB_KITCHEN_PRINT_RULE"] = "PERMISSION_POS_WEB_KITCHEN_PRINT_RULE";
    /** 总部标签 */
    IPermissonCode["PERMISSION_POS_WEB_LABEL_PRINT_RULE"] = "PERMISSION_POS_WEB_LABEL_PRINT_RULE";
    /** 门店收银 */
    IPermissonCode["PERMISSION_POS_WEB_CASHIER_PRINT_RULE_BRANCH"] = "PERMISSION_POS_WEB_CASHIER_PRINT_RULE_BRANCH";
    /** 门店后厨 */
    IPermissonCode["PERMISSION_POS_WEB_KITCHEN_PRINT_RULE_BRANCH"] = "PERMISSION_POS_WEB_KITCHEN_PRINT_RULE_BRANCH";
    /** 门店标签 */
    IPermissonCode["PERMISSION_POS_WEB_LABEL_PRINT_RULE_BRANCH"] = "PERMISSION_POS_WEB_LABEL_PRINT_RULE_BRANCH";
    /** 打印业务 */
    IPermissonCode["PERMISSION_SETTING_PRINT_BUSINESS"] = "PERMISSION_SETTING_PRINT_BUSINESS";
    IPermissonCode["PERMISSION_SETTING_ROLE"] = "PERMISSION_SETTING_ROLE";
    /** 零售供应链-商品同步 */
    IPermissonCode["PERMISSION_APP_EARTH_BRIDGE"] = "PERMISSION_APP_EARTH_BRIDGE";
    /** 零售供应链-门店列表 */
    IPermissonCode["PERMISSION_APP_EARTH_BRIDGE_LOCATION"] = "PERMISSION_APP_EARTH_BRIDGE_LOCATION";
    /** 零售供应链-单据日志 */
    IPermissonCode["PERMISSION_APP_EARTH_BRIDGE_ORDER_LOG"] = "PERMISSION_APP_EARTH_BRIDGE_ORDER_LOG";
    /** 零售供应链-授权设置 */
    IPermissonCode["PERMISSION_APP_EARTH_BRIDGE_AUTH"] = "PERMISSION_APP_EARTH_BRIDGE_AUTH";
    /** 零售供应链-零售供应链设置 */
    IPermissonCode["PERMISSION_EARTH_CHAIN_SETTING"] = "PERMISSION_EARTH_CHAIN_SETTING";
    IPermissonCode["PERMISSION_SETTING_NOTIFY"] = "PERMISSION_SETTING_NOTIFY";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_POINT_EXCHANGE_SHOP"] = "PERMISSION_WESTORE_SHOP_DECORATION_POINT_EXCHANGE_SHOP";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_MEMBER_DEPOSIT"] = "PERMISSION_WESTORE_SHOP_DECORATION_MEMBER_DEPOSIT";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_GET_TICKET_CENTER"] = "PERMISSION_WESTORE_SHOP_DECORATION_GET_TICKET_CENTER";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_ORDER_LIST"] = "PERMISSION_WESTORE_SHOP_DECORATION_ORDER_LIST";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_MP_PAGE"] = "PERMISSION_WESTORE_SHOP_DECORATION_MP_PAGE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_BOOT_PAGE"] = "PERMISSION_WESTORE_SHOP_DECORATION_BOOT_PAGE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_COLLECT_STAMP"] = "PERMISSION_WESTORE_SHOP_DECORATION_COLLECT_STAMP";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_COPYRIGHT_LOGO"] = "PERMISSION_WESTORE_SHOP_DECORATION_COPYRIGHT_LOGO";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_NUMBER_CONFIRM"] = "PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_NUMBER_CONFIRM";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_CUSTOM_COMPONENT"] = "PERMISSION_WESTORE_SHOP_DECORATION_CUSTOM_COMPONENT";
    IPermissonCode["PERMISSION_WESTORE_SHOP_LOADING_ANIMATION"] = "PERMISSION_WESTORE_SHOP_LOADING_ANIMATION";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_ADD_DISH"] = "PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_ADD_DISH";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_FLOATING_WINDOW"] = "PERMISSION_WESTORE_SHOP_DECORATION_FLOATING_WINDOW";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_GIFT_CARD"] = "PERMISSION_WESTORE_SHOP_DECORATION_GIFT_CARD";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_GIFT_LUCKY_DRAW"] = "PERMISSION_WESTORE_SHOP_DECORATION_GIFT_LUCKY_DRAW";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_PAGE_TEMPLATE"] = "PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_PAGE_TEMPLATE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_LIMITED_DISCOUNT"] = "PERMISSION_WESTORE_SHOP_DECORATION_LIMITED_DISCOUNT";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_LISTING_TEMPLATE"] = "PERMISSION_WESTORE_SHOP_DECORATION_LISTING_TEMPLATE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_SHOP_HOMEPAGE"] = "PERMISSION_WESTORE_SHOP_DECORATION_SHOP_HOMEPAGE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_CONFIRM_ORDER"] = "PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_CONFIRM_ORDER";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_ORDER_DETAIL"] = "PERMISSION_WESTORE_SHOP_DECORATION_ORDER_DETAIL";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_SUCCESS"] = "PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_SUCCESS";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_RESERVE"] = "PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_RESERVE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_NAVIGATION"] = "PERMISSION_WESTORE_SHOP_DECORATION_SCAN_ORDER_NAVIGATION";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_SEARCH_PAGE"] = "PERMISSION_WESTORE_SHOP_DECORATION_SEARCH_PAGE";
    IPermissonCode["PERMISSION_WESTORE_CARD_SHARING"] = "PERMISSION_WESTORE_CARD_SHARING";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_TAXON_TEMPLATE"] = "PERMISSION_WESTORE_SHOP_DECORATION_TAXON_TEMPLATE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_NAVIGATION"] = "PERMISSION_WESTORE_SHOP_DECORATION_NAVIGATION";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_SHOP_STYLE"] = "PERMISSION_WESTORE_SHOP_DECORATION_SHOP_STYLE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_TABLE_MEAL"] = "PERMISSION_WESTORE_SHOP_DECORATION_TABLE_MEAL";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_PERSONAL_CENTER_PAGE"] = "PERMISSION_WESTORE_SHOP_DECORATION_PERSONAL_CENTER_PAGE";
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_CONTENT"] = "PERMISSION_WESTORE_SHOP_DECORATION_PRODUCT_CONTENT";
    IPermissonCode["PERMISSION_PRODUCT_KIT"] = "PERMISSION_PRODUCT_KIT";
    IPermissonCode["PERMISSION_SETTING_METAFIELD"] = "PERMISSION_SETTING_METAFIELD";
    /** 桌台预定 */
    IPermissonCode["PERMISSION_ORDER_TABLE_RESERVE"] = "PERMISSION_ORDER_TABLE_RESERVE";
    /** RFM分析 */
    IPermissonCode["PERMISSION_CUSTOMER_RFM_REPORT"] = "PERMISSION_CUSTOMER_RFM_REPORT";
    /** 用户画像 */
    IPermissonCode["PERMISSION_CUSTOMER_PERSONA"] = "PERMISSION_CUSTOMER_PERSONA";
    /** 企微概览 */
    IPermissonCode["PERMISSION_WECOM_OVERVIEW"] = "PERMISSION_WECOM_OVERVIEW";
    /** 系统日志 */
    IPermissonCode["PERMISSION_SET_SYSTEM_LOG"] = "PERMISSION_SET_SYSTEM_LOG";
    /** 员工角色 */
    IPermissonCode["PERMISSION_POS_WEB_STAFF_ROLE"] = "PERMISSION_POS_WEB_STAFF_ROLE";
    /** 小程序推广 */
    IPermissonCode["PERMISSION_WESTORE_WECHAT_MP_PAGE_QR_CODE"] = "PERMISSION_WESTORE_WECHAT_MP_PAGE_QR_CODE";
    /** 用户管理 */
    IPermissonCode["PERMISSION_SETTING_ACCOUNT_PERMISSION"] = "PERMISSION_SETTING_ACCOUNT_PERMISSION";
    /** 门店商品 */
    IPermissonCode["PERMISSION_POS_WEB_PRODUCT"] = "PERMISSION_POS_WEB_PRODUCT";
    /** 取餐屏设置 */
    IPermissonCode["PERMISSION_SETTING_TAKE_SCREEN"] = "PERMISSION_SETTING_TAKE_SCREEN";
    /** 裱花网络 */
    IPermissonCode["PERMISSION_SETTING_CAKE_DECORATOR"] = "PERMISSION_SETTING_CAKE_DECORATOR";
    IPermissonCode["PERMISSION_POS_WEB_POS_LOCATION_INFO"] = "PERMISSION_POS_WEB_POS_LOCATION_INFO";
    /** 数据概览 */
    IPermissonCode["PERMISSION_MERCHANT_PAY_DASHBOARD"] = "PERMISSION_MERCHANT_PAY_DASHBOARD";
    /** 开票记录 */
    IPermissonCode["PERMISSION_INVOICE_RECORD"] = "PERMISSION_INVOICE_RECORD";
    /** 销售员统计 */
    IPermissonCode["PERMISSION_ANALYZE_POS_STAFF"] = "PERMISSION_ANALYZE_POS_STAFF";
    /** 物品档案 */
    IPermissonCode["PERMISSION_FILES_RPODUCT_FILES"] = "PERMISSION_FILES_RPODUCT_FILES";
    /** 仓库档案 */
    IPermissonCode["PERMISSION_FILES_WAREHOUSE_FILES"] = "PERMISSION_FILES_WAREHOUSE_FILES";
    /** 品牌管理 */
    IPermissonCode["PERMISSION_FILES_PRODUCT_VENDOR"] = "PERMISSION_FILES_PRODUCT_VENDOR";
    /** 补货向导 */
    IPermissonCode["PERMISSION_DISTRIBUTION_MANAGEMENT_REQUEST_GUIDE"] = "PERMISSION_DISTRIBUTION_MANAGEMENT_REQUEST_GUIDE";
    /** 采购订单监控 */
    IPermissonCode["PERMISSION_PURCHASE_ORDER_MONITOR"] = "PERMISSION_PURCHASE_ORDER_MONITOR";
    /** 供应商直发明细表 */
    IPermissonCode["PERMISSION_PURCHASE_ORDER_SUPPLIER_SHIPMENT_DETAIL"] = "PERMISSION_PURCHASE_ORDER_SUPPLIER_SHIPMENT_DETAIL";
    /** 加工品原料耗用分析表 */
    IPermissonCode["PERMISSION_PRODUCE_MATERIAL_USE_ANALYZE"] = "PERMISSION_PRODUCE_MATERIAL_USE_ANALYZE";
    /** 应产率报表 */
    IPermissonCode["PERMISSION_SHOULD_PRODUCE_RATE_ANALYZE"] = "PERMISSION_SHOULD_PRODUCE_RATE_ANALYZE";
    /** 生产人员生产汇总表 */
    IPermissonCode["PERMISSION_STOCK_PRODUCE_OPERATOR_PRODUCE_SUMMARY"] = "PERMISSION_STOCK_PRODUCE_OPERATOR_PRODUCE_SUMMARY";
    /** 门店费用汇总 */
    IPermissonCode["PERMISSION_STOCK_LOCATION_FEE_SUMMARY"] = "PERMISSION_STOCK_LOCATION_FEE_SUMMARY";
    IPermissonCode["PERMISSION_PLATFORM_PRODUCT_AUDIT"] = "PERMISSION_PLATFORM_PRODUCT_AUDIT";
    IPermissonCode["PERMISSION_PLATFORM_PRODUCT"] = "PERMISSION_PLATFORM_PRODUCT";
    IPermissonCode["PERMISSION_WESTORE_PRODUCT"] = "PERMISSION_WESTORE_PRODUCT";
    /** ic卡导入 */
    IPermissonCode["PERMISSION_CUSTOMER_IC_CARD"] = "PERMISSION_CUSTOMER_IC_CARD";
    /** 要货单提交状态表 */
    IPermissonCode["PERMISSION_CHAIN_REQUEST_ORDER_COMMIT_STATE"] = "PERMISSION_CHAIN_REQUEST_ORDER_COMMIT_STATE";
    /** 商品报损 */
    IPermissonCode["PERMISSION_STOCK_PRODUCT_REPORT_LOSS"] = "PERMISSION_STOCK_PRODUCT_REPORT_LOSS";
    /**京东秒送 门店商品 */
    IPermissonCode["PERMISSION_OMS_JD_LOCATION_PRODUCT"] = "PERMISSION_OMS_JD_LOCATION_PRODUCT";
    IPermissonCode["PERMISSION_OMS_JD_AUTHROIZE_MANAGE"] = "PERMISSION_OMS_JD_AUTHROIZE_MANAGE";
    /**京东秒送 门店设置 */
    IPermissonCode["PERMISSION_OMS_JD_LOCATION_SET"] = "PERMISSION_OMS_JD_LOCATION_SET";
    /** 淘宝闪购·餐饮设置 */
    IPermissonCode["PERMISSION_OMS_JD_SETTING"] = "PERMISSION_OMS_JD_SETTING";
    /**美团闪购 门店商品 */
    IPermissonCode["PERMISSION_OMS_MTSG_LOCATION_PRODUCT"] = "PERMISSION_OMS_MTSG_LOCATION_PRODUCT";
    IPermissonCode["PERMISSION_OMS_MTSG_AUTHROIZE_MANAGE"] = "PERMISSION_OMS_MTSG_AUTHROIZE_MANAGE";
    /**美团闪购 门店设置 */
    IPermissonCode["PERMISSION_OMS_MTSG_LOCATION_SET"] = "PERMISSION_OMS_MTSG_LOCATION_SET";
    /** 美团闪购设置 */
    IPermissonCode["PERMISSION_OMS_MTSG_SETTING"] = "PERMISSION_OMS_MTSG_SETTING";
    /** 商品成本明细 */
    IPermissonCode["PERMISSION_ITEM_COST_DETAIL"] = "PERMISSION_ITEM_COST_DETAIL";
    /** 服务费 */
    IPermissonCode["PERMISSION_BUSINESS_SERVICE_FEE"] = "PERMISSION_BUSINESS_SERVICE_FEE";
    /** 第二件半价  */
    IPermissonCode["PERMISSION_APP_SECOND_HALF_DISCOUNT"] = "PERMISSION_APP_SECOND_HALF_DISCOUNT";
    /** 服务费统计 */
    IPermissonCode["PERMISSION_ANALYZE_SERVICE_FEE_ITEM"] = "PERMISSION_ANALYZE_SERVICE_FEE_ITEM";
    IPermissonCode["PERMISSION_ANALYZE_PLATFORM_TICKET_VERIFY_LOG"] = "PERMISSION_ANALYZE_PLATFORM_TICKET_VERIFY_LOG";
    IPermissonCode["PERMISSION_WECOM_GROUP_TAG"] = "PERMISSION_WECOM_GROUP_TAG";
    IPermissonCode["PERMISSION_WECOM_CUSTOMER_TAG"] = "PERMISSION_WECOM_CUSTOMER_TAG";
    IPermissonCode["PERMISSION_SETTING_LOCATION_DUPLICATE"] = "PERMISSION_SETTING_LOCATION_DUPLICATE";
    /** 供应链门店复制 */
    IPermissonCode["PERMISSION_STOCK_LOCATION_SYNC"] = "PERMISSION_STOCK_LOCATION_SYNC";
    IPermissonCode["PERMISSION_ANALYZE_PRODUCT_CLEARANCE_LOG"] = "PERMISSION_ANALYZE_PRODUCT_CLEARANCE_LOG";
    /** 断货分析 */
    IPermissonCode["PERMISSION_STOCK_INTERRUPT_INVENTORY_REPORT"] = "PERMISSION_STOCK_INTERRUPT_INVENTORY_REPORT";
    /** 库存预警 */
    IPermissonCode["PERMISSION_STOCK_WARN_INVENTORY_REPORT"] = "PERMISSION_STOCK_WARN_INVENTORY_REPORT";
    IPermissonCode["PARENT_PERMISSION_MSG_CHANNEL"] = "PARENT_PERMISSION_MSG_CHANNEL";
    IPermissonCode["PARENT_PERMISSION_SMS_TMPL"] = "PARENT_PERMISSION_SMS_TMPL";
    IPermissonCode["PARENT_PERMISSION_SMS_TMPL_TYPE"] = "PARENT_PERMISSION_SMS_TMPL_TYPE";
    /** 门店子商户 */
    IPermissonCode["PERMISSION_MERCHANT_PAY_LOCATION_SUB_APP"] = "PERMISSION_MERCHANT_PAY_LOCATION_SUB_APP";
    /** 套餐页面装修 */
    IPermissonCode["PERMISSION_WESTORE_SHOP_DECORATION_PACKAGE_PAGE_DECORATION"] = "PERMISSION_WESTORE_SHOP_DECORATION_PACKAGE_PAGE_DECORATION";
    IPermissonCode["PERMISSION_SETTING_VOUCHER"] = "PERMISSION_SETTING_VOUCHER";
    /** 超量折扣 */
    IPermissonCode["PERMISSION_STOCK_EXCEED_DISCOUNT_ORDER"] = "PERMISSION_STOCK_EXCEED_DISCOUNT_ORDER";
    /** 配送跟踪 */
    IPermissonCode["PERMISSION_TRANSFER_TRACK"] = "PERMISSION_TRANSFER_TRACK";
    IPermissonCode["PERMISSION_CHAIN_PRODUCT_LOCATION_PRICE"] = "PERMISSION_CHAIN_PRODUCT_LOCATION_PRICE";
    /** 物品改价记录 */
    IPermissonCode["PERMISSION_FILES_ITEM_PRICE_LOG"] = "PERMISSION_FILES_ITEM_PRICE_LOG";
    /** 采购向导 */
    IPermissonCode["PERMISSION_PURCHASING_MANAGEMENT_PURCHASE_GUIDE"] = "PERMISSION_PURCHASING_MANAGEMENT_PURCHASE_GUIDE";
    /** 收入优惠统计 */
    IPermissonCode["PERMISSION_ANALYZE_BUSINESS_INCOME_DISCOUNT"] = "PERMISSION_ANALYZE_BUSINESS_INCOME_DISCOUNT";
    /** 通知发布 */
    IPermissonCode["PERMISSION_NOTICE_CENTER_SEND_MSG"] = "PERMISSION_NOTICE_CENTER_SEND_MSG";
    /** 库存周转率 */
    IPermissonCode["PERMISSION_STOCK_INVENTORY_TURNOVER_RATE"] = "PERMISSION_STOCK_INVENTORY_TURNOVER_RATE";
    /** 外卖菜品下发 */
    IPermissonCode["PERMISSION_TAKEOUT_DISH_ISSUE"] = "PERMISSION_TAKEOUT_DISH_ISSUE";
    /** 销售客户 */
    IPermissonCode["PERMISSION_WHOLESALE_CUSTOMER_CATEGORY"] = "PERMISSION_WHOLESALE_CUSTOMER_CATEGORY";
    /** 销售客户分类 */
    IPermissonCode["PERMISSION_WHOLESALE_CUSTOMER_FILE"] = "PERMISSION_WHOLESALE_CUSTOMER_FILE";
    /** 开票申请 */
    IPermissonCode["PERMISSION_INVOICE_APPLY"] = "PERMISSION_INVOICE_APPLY";
    /** 销售管理 */
    IPermissonCode["PARENT_PERMISSION_WHOLESALE_MANAGEMENT"] = "PARENT_PERMISSION_WHOLESALE_MANAGEMENT";
    /** 销售发货单 */
    IPermissonCode["PERMISSION_STOCK_WHOLESALE_DELIVERY_ORDER"] = "PERMISSION_STOCK_WHOLESALE_DELIVERY_ORDER";
    /** 销售报价单 */
    IPermissonCode["PERMISSION_STOCK_WHOLESALE_QUOTE_ORDER"] = "PERMISSION_STOCK_WHOLESALE_QUOTE_ORDER";
    /** 销售退货单 */
    IPermissonCode["PERMISSION_STOCK_WHOLESALE_RETURN_ORDER"] = "PERMISSION_STOCK_WHOLESALE_RETURN_ORDER";
    /** 业务操作 */
    IPermissonCode["PARENT_PERMISSION_WHOLESALE_MANAGEMENT_BUSINESS_OPERATION_CATEGORY"] = "PARENT_PERMISSION_WHOLESALE_MANAGEMENT_BUSINESS_OPERATION_CATEGORY";
    /** 客户物品销售查询 */
    IPermissonCode["PERMISSION_WHOLESALE_REPORT"] = "PERMISSION_WHOLESALE_REPORT";
    /** 菜品下发 */
    IPermissonCode["PERMISSION_PRODUCT_DISTRIBUTION"] = "PERMISSION_PRODUCT_DISTRIBUTION";
    /** 菜谱模版 */
    IPermissonCode["PERMISSION_PRODUCT_RECIPE_TEMPLATE_CATEGORY"] = "PERMISSION_PRODUCT_RECIPE_TEMPLATE_CATEGORY";
    /** 定时变价 */
    IPermissonCode["PERMISSION_PRODUCT_TIMED_PRICE"] = "PERMISSION_PRODUCT_TIMED_PRICE";
    /** 下发记录 */
    IPermissonCode["PERMISSION_PRODUCT_DISTRIBUTION_RECORD"] = "PERMISSION_PRODUCT_DISTRIBUTION_RECORD";
})(IPermissonCode || (exports.IPermissonCode = IPermissonCode = {}));
var IPermissonCodeKey;
(function (IPermissonCodeKey) {
    /** 创建 */
    IPermissonCodeKey["CREATE"] = "CREATE";
    /** 启用/停用 */
    IPermissonCodeKey["TOGGLE"] = "TOGGLE";
    /** 下发（上新及更新） */
    IPermissonCodeKey["SEND"] = "SEND";
    /** 下发（仅更新） */
    IPermissonCodeKey["SEND_UPDATE"] = "SEND_UPDATE";
    /** 下发（更换门店时段菜单） */
    IPermissonCodeKey["SEND_CHANGE"] = "SEND_CHANGE";
    /** 下发（删除门店时段菜单） */
    IPermissonCodeKey["SEND_DELETE"] = "SEND_DELETE";
    /** 清空门店时段菜单 */
    IPermissonCodeKey["CLEAR"] = "CLEAR";
    /** 查看下发记录 */
    IPermissonCodeKey["SEND_LOG"] = "SEND_LOG";
    /** 抖音会员通配置 */
    IPermissonCodeKey["DY_MEMBER_PASS_CONFIG"] = "DY_MEMBER_PASS_CONFIG";
    /** 下载 */
    IPermissonCodeKey["DOWNLOAD"] = "DOWNLOAD";
    /** 中止 */
    IPermissonCodeKey["STOP"] = "STOP";
    IPermissonCodeKey["SAVE_RULE"] = "SAVE_RULE";
    IPermissonCodeKey["EDIT_RULE"] = "EDIT_RULE";
    IPermissonCodeKey["SAVE_CODE"] = "SAVE_CODE";
    IPermissonCodeKey["DOWNLOAD_CORE"] = "DOWNLOAD_CORE";
    /** 复制 */
    IPermissonCodeKey["COPY"] = "COPY";
    /** 月结 */
    IPermissonCodeKey["SETTLEMENT"] = "SETTLEMENT";
    /** 反月结 */
    IPermissonCodeKey["ANTI_SETTLEMENT"] = "ANTI_SETTLEMENT";
    /** 修改要货日期 */
    IPermissonCodeKey["EDIT_GOODS_DATE"] = "EDIT_GOODS_DATE";
    IPermissonCodeKey["MAINTENANCE_RESULT"] = "MAINTENANCE_RESULT";
    /** 授权 */
    IPermissonCodeKey["AUTHROIZE"] = "AUTHROIZE";
    /** 重新开票 */
    IPermissonCodeKey["RE_INVOICE"] = "RE_INVOICE";
    /** 重新发送 */
    IPermissonCodeKey["RE_SEND"] = "RE_SEND";
    /** 授权 */
    IPermissonCodeKey["BATCH_DELETE"] = "BATCH_DELETE";
    /** 取消授权 */
    IPermissonCodeKey["CANCEL_AUTHROIZE"] = "CANCEL_AUTHROIZE";
    /** 关联 */
    IPermissonCodeKey["BIND"] = "BIND";
    /** 取消关联 */
    IPermissonCodeKey["CANCEL_BIND"] = "CANCEL_BIND";
    /** 一键匹配 */
    IPermissonCodeKey["MATCH"] = "MATCH";
    /** 拉取 */
    IPermissonCodeKey["PULL"] = "PULL";
    /** 购买 */
    IPermissonCodeKey["PURCHASE"] = "PURCHASE";
    /** 查看 */
    IPermissonCodeKey["QUERY"] = "QUERY";
    /** 查看历史记录 */
    IPermissonCodeKey["QUERY_LOG"] = "QUERY_LOG";
    /** 编辑 */
    IPermissonCodeKey["EDIT"] = "EDIT";
    /** 挂账还款 */
    IPermissonCodeKey["ON_ACCOUNT"] = "ON_ACCOUNT";
    /** 删除 */
    IPermissonCodeKey["DELETE"] = "DELETE";
    /** 审核 */
    IPermissonCodeKey["AUDIT"] = "AUDIT";
    /** 反审核 */
    IPermissonCodeKey["RE_AUDIT"] = "RE_AUDIT";
    /** 作废 */
    IPermissonCodeKey["CANCEL"] = "CANCEL";
    /** 打印 */
    IPermissonCodeKey["PRINT"] = "PRINT";
    /** 导出 */
    IPermissonCodeKey["EXPORT"] = "EXPORT";
    /** 批复 */
    IPermissonCodeKey["REPLY"] = "REPLY";
    /** 同意 */
    IPermissonCodeKey["AGREE"] = "AGREE";
    /** 拒绝 */
    IPermissonCodeKey["REJECT"] = "REJECT";
    /** 导入 */
    IPermissonCodeKey["IMPORT"] = "IMPORT";
    /** 生成调入门店调入单 */
    IPermissonCodeKey["TRANSFER_IN_LOCATION_TRANSFER_IN_ORDER"] = "TRANSFER_IN_LOCATION_TRANSFER_IN_ORDER";
    /** 生成调出门店调出单 */
    IPermissonCodeKey["TRANSFER_OUT_LOCATION_TRANSFER_OUT_ORDER"] = "TRANSFER_OUT_LOCATION_TRANSFER_OUT_ORDER";
    /** 创建 */
    IPermissonCodeKey["SAVE"] = "SAVE";
    /** 批量下发做法 */
    IPermissonCodeKey["PROPERTY_SAVE"] = "PROPERTY_SAVE";
    /** 批量下发加料 */
    IPermissonCodeKey["PROPERTY_FEED_SAVE"] = "PROPERTY_FEED_SAVE";
    /** 批量下发分类 */
    IPermissonCodeKey["TYPE_SAVE"] = "TYPE_SAVE";
    /** 复制 */
    IPermissonCodeKey["DUPLICATE"] = "DUPLICATE";
    /** 解绑 */
    IPermissonCodeKey["UNBIND"] = "UNBIND";
    /** 关联商品 */
    IPermissonCodeKey["RELATE_PRODUCT"] = "RELATE_PRODUCT";
    /** 替换物品 */
    IPermissonCodeKey["REPLACE_ITEM"] = "REPLACE_ITEM";
    /** 下发 */
    IPermissonCodeKey["ISSUE"] = "ISSUE";
    /** 批量下发 */
    IPermissonCodeKey["BATCH_ISSUE"] = "BATCH_ISSUE";
    /** 绑定/解绑门店 */
    IPermissonCodeKey["BIND_UNBIND_LOCATION"] = "BIND_UNBIND_LOCATION";
    /** 管理门店团购券 */
    IPermissonCodeKey["MANAGE_LOCATION_GROUP_BUY_TICKET"] = "MANAGE_LOCATION_GROUP_BUY_TICKET";
    /** 下发管理 */
    IPermissonCodeKey["ISSUE_MGR"] = "ISSUE_MGR";
    /** 最近采购记录 */
    IPermissonCodeKey["PURCHASE_LOG"] = "PURCHASE_LOG";
    /** 设为主供应商 */
    IPermissonCodeKey["MAIN_SUPPLIER"] = "MAIN_SUPPLIER";
    /** 冲红复制 */
    IPermissonCodeKey["BLUSH_DUPLICATE"] = "BLUSH_DUPLICATE";
    /** 批量编辑 */
    IPermissonCodeKey["BATCH_EDIT"] = "BATCH_EDIT";
    /** 采购单价查询 */
    IPermissonCodeKey["PURCHASE_PRICE_QUERY"] = "PURCHASE_PRICE_QUERY";
    /** 采购单价编辑 */
    IPermissonCodeKey["PURCHASE_PRICE_EDIT"] = "PURCHASE_PRICE_EDIT";
    /** 采购最近进价查询 */
    IPermissonCodeKey["RECENT_PURCHASE_PRICE_QUERY"] = "RECENT_PURCHASE_PRICE_QUERY";
    /** 收货单价查询 */
    IPermissonCodeKey["RECEIVE_PRICE_QUERY"] = "RECEIVE_PRICE_QUERY";
    /** 收货单价编辑 */
    IPermissonCodeKey["RECEIVE_PRICE_EDIT"] = "RECEIVE_PRICE_EDIT";
    /** 退货单价查询 */
    IPermissonCodeKey["RETURN_PRICE_QUERY"] = "RETURN_PRICE_QUERY";
    /** 退货单价编辑 */
    IPermissonCodeKey["RETURN_PRICE_EDIT"] = "RETURN_PRICE_EDIT";
    /** 生成领料单 */
    IPermissonCodeKey["GENERATE_MATERIAL"] = "GENERATE_MATERIAL";
    /** 生成加工单 */
    IPermissonCodeKey["GENERATE_PRODUCE"] = "GENERATE_PRODUCE";
    /** 批量打印 */
    IPermissonCodeKey["BATCH_PRINT"] = "BATCH_PRINT";
    /** 批量设置打印模版 */
    IPermissonCodeKey["BATCH_SET_PRINT_TMPL"] = "BATCH_SET_PRINT_TMPL";
    /** 选择模版 */
    IPermissonCodeKey["SELECT_TMPL"] = "SELECT_TMPL";
    /** 清除模板 */
    IPermissonCodeKey["CLEAR_TMPL"] = "CLEAR_TMPL";
    /** 退款 */
    IPermissonCodeKey["REFUND"] = "REFUND";
    /** 重新分账 */
    IPermissonCodeKey["RE_SETTLE"] = "RE_SETTLE";
    /** 员工信息 */
    IPermissonCodeKey["STAFF"] = "STAFF";
    /** 团餐设置 */
    IPermissonCodeKey["GROUP_MEAL_SETTING"] = "GROUP_MEAL_SETTING";
    /** 额度调整 */
    IPermissonCodeKey["CREDIT_LIMIT_CHANGE"] = "CREDIT_LIMIT_CHANGE";
    /** 毛利 */
    IPermissonCodeKey["GROSS_MONEY"] = "GROSS_MONEY";
    IPermissonCodeKey["ADJUST_RECORD_MONEY"] = "ADJUST_RECORD_MONEY";
    IPermissonCodeKey["IMPORT_ADJUST_RECORD_MONEY"] = "IMPORT_ADJUST_RECORD_MONEY";
    IPermissonCodeKey["ALLOCATION_TASK"] = "ALLOCATION_TASK";
    IPermissonCodeKey["CANCEL_TASK"] = "CANCEL_TASK";
    IPermissonCodeKey["ALLOCATION_CANCEL"] = "ALLOCATION_CANCEL";
    IPermissonCodeKey["PRODUCE_BEGIN"] = "PRODUCE_BEGIN";
    IPermissonCodeKey["COMPLETE"] = "COMPLETE";
    IPermissonCodeKey["REMIND_SEND"] = "REMIND_SEND";
    /** 更新 */
    IPermissonCodeKey["UPDATE"] = "UPDATE";
    /** 禁用 */
    IPermissonCodeKey["DISABLE"] = "DISABLE";
    /** 启用*/
    IPermissonCodeKey["ENABLE"] = "ENABLE";
    IPermissonCodeKey["SYNC"] = "SYNC";
    IPermissonCodeKey["APPLY_TAG"] = "APPLY_TAG";
    IPermissonCodeKey["STAFF_INFO"] = "STAFF_INFO";
    IPermissonCodeKey["ACCOUNT_INFO"] = "ACCOUNT_INFO";
    IPermissonCodeKey["APPOINT_STAFF"] = "APPOINT_STAFF";
    IPermissonCodeKey["DATA"] = "DATA";
    IPermissonCodeKey["BEGIN"] = "BEGIN";
    /** 批量发货 */
    IPermissonCodeKey["FULFILL"] = "FULFILL";
    IPermissonCodeKey["end"] = "end";
    IPermissonCodeKey["END"] = "END";
    IPermissonCodeKey["SUSPEND"] = "SUSPEND";
    IPermissonCodeKey["BUY_AND_RENEW"] = "BUY_AND_RENEW";
    IPermissonCodeKey["RESTOCK"] = "RESTOCK";
    IPermissonCodeKey["RETURN"] = "RETURN";
    IPermissonCodeKey["CANCEL_ARCHIVE"] = "CANCEL_ARCHIVE";
    IPermissonCodeKey["AGREE_REFUND"] = "AGREE_REFUND";
    IPermissonCodeKey["REFUSE_REFUND"] = "REFUSE_REFUND";
    IPermissonCodeKey["ACCEPT"] = "ACCEPT";
    IPermissonCodeKey["REFUSE"] = "REFUSE";
    IPermissonCodeKey["DOWNLOAD_CODE"] = "DOWNLOAD_CODE";
    IPermissonCodeKey["DELETE_GROUP"] = "DELETE_GROUP";
    IPermissonCodeKey["EDIT_GROUP"] = "EDIT_GROUP";
    IPermissonCodeKey["SAVE_GROUP"] = "SAVE_GROUP";
    /** 激活 */
    IPermissonCodeKey["ACTIVE"] = "ACTIVE";
    IPermissonCodeKey["CONFIG_LOCATION"] = "CONFIG_LOCATION";
    IPermissonCodeKey["READY_FULFILL"] = "READY_FULFILL";
    IPermissonCodeKey["CANCEL_FULFILL"] = "CANCEL_FULFILL";
    IPermissonCodeKey["CONFIRM_ARRIVED"] = "CONFIRM_ARRIVED";
    IPermissonCodeKey["FREEZE"] = "FREEZE";
    IPermissonCodeKey["UN_FREEZE"] = "UN_FREEZE";
    IPermissonCodeKey["UPDATE_TYPE"] = "UPDATE_TYPE";
    IPermissonCodeKey["EXCHANGE"] = "EXCHANGE";
    IPermissonCodeKey["BALANCE_MERGE"] = "BALANCE_MERGE";
    IPermissonCodeKey["RETRIEVE"] = "RETRIEVE";
    IPermissonCodeKey["DEPOSIT"] = "DEPOSIT";
    IPermissonCodeKey["ADJUST_BALANCE"] = "ADJUST_BALANCE";
    IPermissonCodeKey["ENABLE_DISABLE"] = "ENABLE_DISABLE";
    IPermissonCodeKey["CLOSE_DISABLE"] = "CLOSE_DISABLE";
    IPermissonCodeKey["ADJUST_GROWTH_VALUE"] = "ADJUST_GROWTH_VALUE";
    IPermissonCodeKey["BATCH_SEND_GIFT_CARD"] = "BATCH_SEND_GIFT_CARD";
    IPermissonCodeKey["ADJUST_POINT"] = "ADJUST_POINT";
    IPermissonCodeKey["ADJUST_LEVEL"] = "ADJUST_LEVEL";
    IPermissonCodeKey["GIVE_TICKET"] = "GIVE_TICKET";
    /**使生效 */
    IPermissonCodeKey["EFFECT"] = "EFFECT";
    /**作废 */
    IPermissonCodeKey["INVALIDATE"] = "INVALIDATE";
    IPermissonCodeKey["OPERATE"] = "OPERATE";
    IPermissonCodeKey["ASSET_MIGRATION"] = "ASSET_MIGRATION";
    IPermissonCodeKey["ADJUST_BELONG_LOCATION"] = "ADJUST_BELONG_LOCATION";
    IPermissonCodeKey["EXTEND"] = "EXTEND";
    IPermissonCodeKey["REWARD"] = "REWARD";
    IPermissonCodeKey["STOP_GIVE"] = "STOP_GIVE";
    IPermissonCodeKey["STOP_USE"] = "STOP_USE";
    IPermissonCodeKey["HAS_PURCHASE"] = "HAS_PURCHASE";
    IPermissonCodeKey["TAGGING"] = "TAGGING";
    IPermissonCodeKey["DISTRIBUTE_LOCATION"] = "DISTRIBUTE_LOCATION";
    IPermissonCodeKey["ENABLE_HOME_PAGE"] = "ENABLE_HOME_PAGE";
    IPermissonCodeKey["SHELF"] = "SHELF";
    IPermissonCodeKey["DISTRIBUTE"] = "DISTRIBUTE";
    IPermissonCodeKey["ARCHIVED"] = "ARCHIVED";
    IPermissonCodeKey["CANCEL_ARCHIVED"] = "CANCEL_ARCHIVED";
    IPermissonCodeKey["QUERY_COST"] = "QUERY_COST";
    IPermissonCodeKey["QUERY_PURCHASE"] = "QUERY_PURCHASE";
    IPermissonCodeKey["QUERY_CHAIN"] = "QUERY_CHAIN";
    /** 确认收货 */
    IPermissonCodeKey["CONFIRM_RECEIVE"] = "CONFIRM_RECEIVE";
    IPermissonCodeKey["RE_DEPOSIT"] = "RE_DEPOSIT";
    IPermissonCodeKey["GENERATE_PRODUCE_ORDER"] = "GENERATE_PRODUCE_ORDER";
    /** 查看配送价 */
    IPermissonCodeKey["QUERY_CHAIN_PRICE"] = "QUERY_CHAIN_PRICE";
    /** 订单商家备注 */
    IPermissonCodeKey["MERCHANT_MEMO"] = "MERCHANT_MEMO";
    /** 成本价格 */
    IPermissonCodeKey["COST_PRICE"] = "QUERY_COST";
    /** 上传附件 */
    IPermissonCodeKey["UPLOAD_IMAGE"] = "UPLOAD_IMAGE";
    /** 呼叫骑手 */
    IPermissonCodeKey["DELEVERY_CALL"] = "DELEVERY_CALL";
    /** 结算确认 */
    IPermissonCodeKey["SETTLE_CONFIRM"] = "SETTLE_CONFIRM";
    /** 查看成本价 */
    IPermissonCodeKey["QUERY_COST_PRICE"] = "QUERY_COST_PRICE";
    /** 导入财务主体 */
    IPermissonCodeKey["IMPORT_SUBJECT"] = "IMPORT_SUBJECT";
    /** 明盘 */
    IPermissonCodeKey["UNBLIND"] = "UNBLIND";
    /** 通知 */
    IPermissonCodeKey["NOTICE"] = "NOTICE";
    /** 修改有效期 */
    IPermissonCodeKey["UPDATE_EXPIRE_DATE"] = "UPDATE_EXPIRE_DATE";
    /** 排序 */
    IPermissonCodeKey["SORT"] = "SORT";
    /** 更新门店下已有菜品 */
    IPermissonCodeKey["UPDATE_EXISTING"] = "UPDATE_EXISTING";
    /** 菜品上新 */
    IPermissonCodeKey["NEW_PRODUCT"] = "NEW_PRODUCT";
    /** 删除已下发菜品 */
    IPermissonCodeKey["DELETE_DISTRIBUTED"] = "DELETE_DISTRIBUTED";
    /** 查看下发任务详情 */
    IPermissonCodeKey["QUERY_DETAIL"] = "QUERY_DETAIL";
    /** 撤回下发任务 */
    IPermissonCodeKey["RECALL"] = "RECALL";
    /**立即下发任务 */
    IPermissonCodeKey["IMMEDIATE_ISSUE"] = "IMMEDIATE_ISSUE";
    /** 终止 */
    IPermissonCodeKey["TERMINATE"] = "TERMINATE";
    /** POS 菜品展示/隐藏 */
    IPermissonCodeKey["POS_DISPLAY"] = "POS_DISPLAY";
    /** APP 菜品展示/隐藏 */
    IPermissonCodeKey["APP_DISPLAY"] = "APP_DISPLAY";
    /** 扫码点餐菜品展示/隐藏 */
    IPermissonCodeKey["SCAN_CODE_DISPLAY"] = "SCAN_CODE_DISPLAY";
    /** 自提菜品展示/隐藏 */
    IPermissonCodeKey["SELF_PICK_DISPLAY"] = "SELF_PICK_DISPLAY";
    /** 外卖菜品展示/隐藏*/
    IPermissonCodeKey["TAKE_AWAY_DISPLAY"] = "TAKE_AWAY_DISPLAY";
    /** 店铺装修 */
    IPermissonCodeKey["CONFIG"] = "CONFIG";
    /** 生成生产指令单 */
    IPermissonCodeKey["GENERATE_COMMAND"] = "GENERATE_COMMAND";
})(IPermissonCodeKey || (exports.IPermissonCodeKey = IPermissonCodeKey = {}));
